import React from "react";
import moment from "moment";
import visionLogo from "../../images/vision-logo.png";
import { generateAndDownloadPdf } from "./pdfs";
import { formatAmount } from "./common";
// export const convertDataToBuyingSheet = (json) => {
//     const DataProduct = {
//         products: {},
//         customers: {},
//         addProduct: function (od) {
//             this.products[`product-${od.ProductID}`] = {
//                 ProductID: od.ProductID,
//                 ProductName: od.ProductName,
//                 agentCode:od.tblAgent.AgentCode,
//                 customers: this.getCustomers()
//             }
//         },
//         addCustomerToProduct: function (od) {
//             const newQty = this.products[`product-${od.ProductID}`].customers[`customer-${od.tblOrder.tblCustomer.CustomerID}`].Qty + od.Qty;
//             const newCustomers = {};
//             newCustomers[`customer-${od.tblOrder.tblCustomer.CustomerID}`] = { ...this.products[`product-${od.ProductID}`].customers[`customer-${od.tblOrder.tblCustomer.CustomerID}`], Qty: newQty }
//             this.products[`product-${od.ProductID}`].customers = { ...this.products[`product-${od.ProductID}`].customers, ...newCustomers }
//         },
//         getProducts: function () {
//             return this.products;
//         },
//         addCustomer: function (od) {
//             this.customers[`customer-${od.tblOrder.tblCustomer.CustomerID}`] = {
//                 CustomerID: od.tblOrder.tblCustomer.CustomerID,
//                 CustomerName: od.tblOrder.tblCustomer.CustomerName,
//                 BuyerCode: od.tblOrder.tblCustomer.BuyerCode,
//                 Qty: 0
//             }
//         },
//         getCustomers: function () {
//             return this.customers
//         }
//     }

//     json.map((od, odIndex) => {
//         DataProduct.addCustomer(od);
//     })
//     json.map((od, odIndex) => {
//         DataProduct.addProduct(od);
//     })
//     json.map((od, odIndex) => {
//         DataProduct.addCustomerToProduct(od);
//     })


//     const productsObj = DataProduct.getProducts();
//     const products = [];
//     for (let productKey in productsObj) {
//         const { ProductID, ProductName, agentCode,customers } = productsObj[productKey]
//         const product = { ProductID, ProductName, agentCode,customers: [], TotalQty: 0}
//         for (let customerKey in customers) {
//             product.customers.push(customers[customerKey])
//             product.TotalQty = product.TotalQty + customers[customerKey].Qty
//         }
//         products.push(product)
//     }
//     return products;
// }

export const convertDataToBuyingSheet = async (json) => {
  const agents = [];
  const customers = [];

  const createAgentData = (agentId, agentCode, EmailAddresses, DNDEmail, productId, productName, className, sizeName, qty, count, buyPrice, customerDetails, orderDate, PrintSort, unitName) => {
    return {
      agentId: agentId,
      agentCode: agentCode,
      DNDEmail: DNDEmail,
      emailAddress: EmailAddresses,
      products: [createProductData(productId, productName, className, sizeName, qty, count, buyPrice, unitName, customerDetails)],
      OrderDate: orderDate,
      PrintSort
    };
  }

  const createProductData = (productId, productName, className, sizeName, qty, count, buyPrice, unitName, customerDetails) => {
    return {
      ProductID: productId,
      // DNDEmail:DNDEmail,
      ProductName: productName,
      ClassName: className,
      SizeName: sizeName,
      Count: count,
      BuyPrice: buyPrice,
      TotalQty: qty,
      UnitName: unitName,
      customers: updateCustomerData(customerDetails, qty)
    };
  }

  const updateCustomerData = (customerDetails, qty) => {
    const customerIndex = customers.findIndex(customer => customer.CustomerID === customerDetails.CustomerID);
    if (customerIndex !== -1) {
      let newCustomers = JSON.parse(JSON.stringify(customers));
      newCustomers[customerIndex].Qty = qty;
      return newCustomers;
    }

  }

  const updateProductData = (productData, qty, customerDetails) => {
    productData.TotalQty += qty;
    const customerIndex = productData.customers.findIndex(customer => customer.CustomerID === customerDetails.CustomerID);
    if (customerIndex !== -1) {
      productData.customers[customerIndex].Qty += qty
    }
  }

  json.forEach((customer) => {
    let customerDetails = customer.tblOrder.tblCustomer;
    const customerIndex = customers.findIndex(customer => customer.CustomerID === customerDetails.CustomerID);
    if (customerIndex === -1) {
      customers.push({
        CustomerName: customerDetails.CustomerName,
        CustomerID: customerDetails.CustomerID,
        BuyerCode: customerDetails.BuyerCode,
        Qty: 0
      })
    }

  });

  json.forEach((od) => {
    const { tblAgent, tblUnit, ProductID, ProductName, ClassName, SizeName, Qty, BuyPrice, Count } = od;
    const { AgentId, AgentCode, DNDEmail, EmailAddresses, PrintSort } = tblAgent;
    const { UnitName } = tblUnit;
    const customerDetails = od.tblOrder.tblCustomer;
    const orderDate = od.tblOrder.OrderDate;

    const agentIndex = agents.findIndex(agent => agent.agentId === AgentId);

    if (agentIndex === -1) {
      agents.push(createAgentData(AgentId, AgentCode, EmailAddresses, DNDEmail, ProductID, ProductName, ClassName, SizeName, Qty, Count, BuyPrice, customerDetails, orderDate, PrintSort, UnitName));
    } else {
      const productIndex = agents[agentIndex].products.findIndex(product => product.ProductID === ProductID);

      if (productIndex === -1) {
        agents[agentIndex].products.push(createProductData(ProductID, ProductName, ClassName, SizeName, Qty, Count, BuyPrice, UnitName, customerDetails));
      } else {
        updateProductData(agents[agentIndex].products[productIndex], Qty, customerDetails);
      }
    }
  });

  agents.forEach(agent => {
    agent.products.forEach(product => {
      const customerGroups = {};

      product.customers.forEach(customer => {
        if (customer.Qty > 0) {
          const qty = customer.Qty.toString();

          if (!customerGroups[qty]) {
            customerGroups[qty] = [];
          }

          const currentGroup = customerGroups[qty];
          const lastIndex = currentGroup.length - 1;

          if (lastIndex >= 0 && currentGroup[lastIndex].length < 5) {
            currentGroup[lastIndex].push(customer);
          } else {
            currentGroup.push([customer]);
          }
        }
      });

      product.customerGroups = customerGroups;
    });

  });

  agents.forEach(agent => {
    agent.products.sort((a, b) => a.ProductName.localeCompare(b.ProductName));
  });

  agents.sort((a, b) => {
    if(a.PrintSort < b.PrintSort) return -1;
    if(a.PrintSort > b.PrintSort) return 1;

    if (a.agentCode < b.agentCode) return -1;
    if (a.agentCode > b.agentCode) return 1;

    return 0; // If AgentCodes, ProductNames, PrintSort are equal
  });


  // Previous Code
  // agents.forEach(agent => {
  //   agent.products.sort((a, b) => a.ProductName.localeCompare(b.ProductName));

  //   let leftSideRows = 13;
  //   let rightSideRows = 13;
  //   let tables = [];
  //   let pages = [];

  //   agent.products.forEach(product => {
  //     let productName = product.ProductName;
  //     let totalQty = product.TotalQty;
  //     let table = { rows: [], productName, totalQty };
  //     let rowCount = rowsNeeded[productName] === 1 ? rowsNeeded[productName] + 1 : rowsNeeded[productName]


  //     Object.keys(product.customerGroups).forEach((key) => {
  //       let item = product.customerGroups[key];
  //       // Add each element of the current item to the table rows separately
  //       item.forEach(element => {
  //         table.rows.push(element);
  //       });
  //     });

  //     if (rowCount >= 13 && (leftSideRows < rowCount || rightSideRows < rowCount)) {
  //       let tempRowCount = rowCount;
  //       let indexValue = 0;
  //       let lenValue = 13;
  //       while (tempRowCount > 0) {
  //         if (leftSideRows) {
  //           leftSideRows -= (lenValue - indexValue)
  //         }
  //         else if (rightSideRows) {
  //           rightSideRows -= (lenValue - indexValue)
  //           leftSideRows = 0
  //         }
  //         else {
  //           pages.push(tables);
  //           tables = []

  //           leftSideRows = pages.length > 0 ? 16 : 13;
  //           rightSideRows = pages.length > 0 ? 16 : 13;

  //           leftSideRows -= (lenValue - indexValue)
  //         }

  //         let tempTable = { rows: [], productName, totalQty };
  //         for (let index = indexValue; index < lenValue; index++) {
  //           let row = table.rows[index];
  //           tempTable.rows.push(row);
  //           indexValue = index + 1
  //         }
  //         tables.push(tempTable)
  //         tempRowCount -= 15;

  //         lenValue = tempRowCount - lenValue > 0 ? tempRowCount - lenValue : indexValue + tempRowCount
  //       }
  //       table = { rows: [], productName, totalQty };
  //     }

  //     else {
  //       if (leftSideRows && leftSideRows >= rowCount) {
  //         leftSideRows -= rowCount
  //       }
  //       else if (rightSideRows && rightSideRows >= rowCount) {
  //         rightSideRows -= rowCount
  //         leftSideRows = 0
  //       }
  //       else {
  //         pages.push(tables);
  //         tables = []

  //         leftSideRows = pages.length > 0 ? 16 : 13;
  //         rightSideRows = pages.length > 0 ? 16 : 13;

  //         leftSideRows -= rowCount
  //       }
  //     }
  //     if (table.rows.length > 0)
  //       tables.push(table); // Push the current table object into tables
  //     table = { rows: [], productName, totalQty }; // Reset table for the next product
  //   });

  //   if (pages.length === 0 || tables.length > 0) {
  //     pages.push(tables)
  //     tables = []
  //     leftSideRows = pages.length > 0 ? 16 : 13;
  //     rightSideRows = pages.length > 0 ? 16 : 13;
  //   }
  //   agent.pages = pages;
  // });

  return agents;
}

export const convertDataToWarehouseSheet = (json, customerId, addBlankRows = 10) => {
  const DataProduct = {
    products: {},
    customers: {},
    allCustomersProduct: [],
    blankRow: {
      "ProductID": "",
      "ProductName": "",
      "Qty": "",
      "UnitID": "",
      "UnitName": ""
    },
    addProduct: function (od) {
      if (this.products[`product-${od.ProductID}-${od.tblUnit.UnitID}-${od.tblOrder.CustomerID}`]) {
        this.products[`product-${od.ProductID}-${od.tblUnit.UnitID}-${od.tblOrder.CustomerID}`] = {
          ...this.products[`product-${od.ProductID}-${od.tblUnit.UnitID}-${od.tblOrder.CustomerID}`],
          Qty: this.products[`product-${od.ProductID}-${od.tblUnit.UnitID}-${od.tblOrder.CustomerID}`].Qty + od.Qty,
          AgentCode: od.tblAgent.AgentCode
        }
      } else {
        this.products[`product-${od.ProductID}-${od.tblUnit.UnitID}-${od.tblOrder.CustomerID}`] = {
          ProductID: od.ProductID,
          ProductName: od.ProductName,
          UnitID: od.tblUnit.UnitID,
          UnitName: od.tblUnit.UnitName,
          Qty: od.Qty,
          CustomerID: od.tblOrder.CustomerID,
          emailAddress: od.tblOrder.tblCustomer.EmailAddresses,
          AgentCode: od.tblAgent.AgentCode
        }
      }
    },
    addAllCustomersProduct: function (od) {
      if (this.allCustomersProduct.findIndex((element) => element.CustomerID == `${od.tblOrder.CustomerID}`) != -1) {
        // store the index of that customer id object
        const index = this.allCustomersProduct.findIndex((element) => element.CustomerID == `${od.tblOrder.CustomerID}`);

        // Now check for the product
        // if (this.allCustomersProduct[index].products.findIndex((product) => product.ProductID == `${od.ProductID}`) != -1) {
        //   const productIndex = this.allCustomersProduct[index].products.findIndex((product) => product.ProductID == `${od.ProductID}`);
        //   this.allCustomersProduct[index].products[productIndex] = {
        //     ...this.allCustomersProduct[index].products[productIndex],
        //     Qty: this.allCustomersProduct[index].products[productIndex].Qty + od.Qty,
        //     AgentCode: od.tblAgent.AgentCode
        //   }

        // } else {
        // if product for that customer is not there
        let newProduct = { ProductID: od.ProductID, ProductName: od.ProductName, UnitID: od.tblUnit?.UnitID, UnitName: od.tblUnit?.UnitName, Qty: od.Qty, AgentCode: od.tblAgent?.AgentCode, Count: od.Count, SellPrice: od.SellPrice, ContainerName: od.ContainerName, ClassName: od.ClassName, SizeName: od.SizeName, WarehouseSort: od.tblAgent?.WarehouseSort }
        this.allCustomersProduct[index].products.push(newProduct);
        // }

      } else {
        // If customer isnot in Array 
        // then add customer and its product both in array
        let newCustomer = { CustomerID: od.tblOrder.CustomerID, BuyerCode: od.tblOrder.tblCustomer.BuyerCode, CustomerCode: od.tblOrder.tblCustomer.CustomerCode, emailAddress: od.tblOrder.tblCustomer.EmailAddresses, DeliveryInstructions: od.tblOrder.DeliveryInstructions, OrderDate: od.tblOrder.OrderDate, OrderNotes: od.tblOrder.OrderNotes, PurchaseOrder: od.tblOrder.PurchaseOrder, PrintOrder: od.tblOrder.PrintOrder, products: [{ ProductID: od.ProductID, ProductName: od.ProductName, Qty: od.Qty, UnitID: od.tblUnit?.UnitID, UnitName: od.tblUnit?.UnitName, AgentCode: od.tblAgent?.AgentCode, Count: od.Count, SellPrice: od.SellPrice, ContainerName: od.ContainerName, ClassName: od.ClassName, SizeName: od.SizeName, WarehouseSort: od.tblAgent?.WarehouseSort }], TotalQty: 0, addBlankRows };
        this.allCustomersProduct.push(newCustomer);
      }
    },
    getProducts: function () {
      return this.products;
    }
  }
  //  if (customerId === "all") {
  json && json.forEach((od, odIndex) => {
    DataProduct.addAllCustomersProduct(od);
  })

  // Customer wise total calculation and adding blank rows
  DataProduct.allCustomersProduct.forEach((customer) => {
    let totalQty = 0;
    customer.products.forEach((cusProd) => {
      totalQty += parseFloat(cusProd.Qty || 0);
    });

    customer.TotalQty = totalQty;
    let agentOHProducts = [];
    let filterProducts = customer.products.filter((product) => {
      if (product.AgentCode != "OH") {
        return product
      }
      else {
        agentOHProducts.push(product)
      }
    })
    filterProducts.sort((a, b) => {
      if (a.WarehouseSort < b.WarehouseSort) return -1;
      if (a.WarehouseSort > b.WarehouseSort) return 1;

      if (a.AgentCode < b.AgentCode) return -1;
      if (a.AgentCode > b.AgentCode) return 1;

      if (a.ProductName < b.ProductName) return -1;
      if (a.ProductName > b.ProductName) return 1;

      return 0; // If AgentCodes, ProductNames, WarehouseSort are equal
    });
    agentOHProducts?.sort((a, b) => a.ProductName.localeCompare(b.ProductName));
    customer.products = [...filterProducts, ...agentOHProducts]
    for (let i = 0; i < addBlankRows; i++) {
      customer.products.push({ ...DataProduct.blankRow });
    }
  });

  return DataProduct.allCustomersProduct;

  //} 
  //else {
  //         json.map((od, odIndex) => {
  //             DataProduct.addProduct(od);
  //         })
  //         const productsObj = DataProduct.getProducts();

  //         const products = [];

  //         for (let productKey in productsObj) {
  //             products.push(productsObj[productKey])
  //         }
  //         return products
  //    }
}
const calculateSpace = (firstPageRows, otherPagesRows, total, rows) => {
  const First_MaxRows = 25;
  const Other_MaxRows = 29;
  let space = 0;
  if (rows <= First_MaxRows) {
    return space
  }

  else {
    let differenceRows = firstPageRows - rows;
    if (rows > firstPageRows) {
      let updatedRows = rows - firstPageRows;
      updatedRows = updatedRows % otherPagesRows;

      if (updatedRows <= Other_MaxRows) {
        return space
      }
      differenceRows = otherPagesRows - updatedRows;
    }

    space += differenceRows * 18
    space += differenceRows === 0 ? 0 : differenceRows <= 3 ? 25 : 42;
  }

  return space;
}
// Total Pages for provided data
export const getTotalPages = (firstPageRows, otherPagesRows, sheetData, isAdditionalRow) => {
  let total = 0;

  sheetData?.forEach((ele) => {
    const productLen = ele.products?.length;
    const remainingData = productLen - firstPageRows;
    const additionalPages = Math.ceil(remainingData / otherPagesRows);

    let totalPages = 1 + additionalPages;

    if (isAdditionalRow && (remainingData % firstPageRows === 0 || remainingData % otherPagesRows === 0)) {
      totalPages++;
    }

    total += totalPages;
  });

  return total;
}

export const printWarehouseSheetAllCustomers = async (warehouseSheetData, preview = false) => {
  const firstPageRows = 34;
  const otherPagesRows = 38;
  const totalPageCount = getTotalPages(firstPageRows, otherPagesRows, warehouseSheetData, true);
  let currentPage = 0;
  const element = warehouseSheetData.map((ele, index) => {
    const currentTotalPage = getTotalPages(firstPageRows, otherPagesRows, [warehouseSheetData[index]], true);
    let currentPageRow = 0;
    let startPage = 1;
    currentPage += 1;
    return (
      <>
        <div className="element-to-print" style={{ height: `${currentTotalPage * 830}px` }}>
          <table
            width="100%"
            cellSpacing={0}
            cellPadding={0}
            bgcolor="ffffff"
            border={0}
          >
            <tbody>
              <tr>
                <td>
                  <table
                    // width="100%"
                    width="600px"
                    cellSpacing={0}
                    cellPadding={0}
                    border={0}
                    style={{ padding: "12px 20px 0px 5px" }}
                  >
                    <tbody>
                      <tr>
                        <td>
                          <img
                            src={visionLogo}
                            alt=""
                            width={120}
                            height={30}
                          />
                        </td>
                        <td
                          style={{
                            // fontFamily: "Outfit",
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: "right"
                          }}
                        >Warehouse Sheet - Vision</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table
                    width="100%"
                    cellSpacing={0}
                    cellPadding={0}
                    border={0}
                    style={{ padding: "8px 25px 6px 25px", backgroundColor: "#fff" }}
                  >
                    <tbody>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing={0} cellPadding={0} border={0}>
                            <tbody>
                              <tr>
                                <td
                                  width="50%"
                                  style={{
                                    fontSize: 12,
                                    color: "#787A80",
                                    fontWeight: 500,
                                    textAlign: "left"
                                  }}
                                >
                                  Customer: {ele.CustomerCode}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <table width="100%" cellSpacing={0} cellPadding={0} border={0}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    width: "50%",
                                    fontSize: 12,
                                    color: "#787A80",
                                    fontWeight: 500,
                                    textAlign: "right"
                                  }}
                                >
                                  Date: {moment(ele.OrderDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <table
                    width="100%"
                    cellSpacing={4}
                    cellPadding={0}
                    style={{ padding: '8px 15px' }}
                  >
                    <thead>
                      <tr>
                        <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "2px", border: "1px solid" }} />
                        <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "2px", border: "1px solid" }} colSpan={2}>Vision Produce</td>
                        <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "2px", border: "1px solid" }}>Qty</td>
                        <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "2px", border: "1px solid" }}>Crate</td>
                        <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "2px", border: "1px solid" }}>Count</td>
                        <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "2px", border: "1px solid" }}>Price</td>
                      </tr>
                    </thead>
                    <tbody>
                      {ele.products.map((product, productIndex) => {
                        let agentCode = productIndex === 0 ? product.AgentCode : ele.products[productIndex - 1].AgentCode !== product.AgentCode ? product.AgentCode : '';
                        let rows = [];
                        if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                          currentPage += 1;
                          startPage += 1;
                          currentPageRow = 0;
                        }
                        currentPageRow += 1;
                        rows.push(
                          <>
                            <tr style={{ height: "18px" }}>
                              <td style={{ fontSize: "8px", width: "7%", textAlign: "right", padding: "2px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.ProductID != '' && agentCode}</td>
                              <td style={{ fontSize: "8px", textAlign: "left", padding: "2px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{`${product.Qty} ${product.UnitName || ''}`}</td>
                              <td style={{ fontSize: "8px", textAlign: "left", padding: "2px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{`${product.ProductName} ${product.ClassName || ''} ${product.SizeName || ''}`}</td>
                              <td style={{ fontSize: "8px", textAlign: "center", padding: "2px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.Qty}</td>
                              <td style={{ fontSize: "8px", textAlign: "center", padding: "2px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.ContainerName}</td>
                              <td style={{ fontSize: "8px", textAlign: "center", padding: "2px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.Count}</td>
                              <td style={{ fontSize: "8px", textAlign: "right", padding: "2px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}></td>
                            </tr>
                            {currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0 && (
                              <tr style={{ height: "34px" }}>
                                <td colSpan="7" style={{ fontSize: "8px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                              </tr>
                            )}
                          </>)
                        if (productIndex === ele.products.length - 1 && ((ele.products.length - firstPageRows) % firstPageRows === 0 || (ele.products.length - firstPageRows) % otherPagesRows === 0)) {
                          currentPage += 1;
                        }
                        return rows;
                      })}
                      {/* <tr>
                    <td style={{ fontSize: "16px", textAlign: "right", padding: "10px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>OH</td>
                    <td style={{ fontSize: "16px", textAlign: "right", padding: "10px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>2 Carton(s)</td>
                    <td style={{ fontSize: "16px", textAlign: "right", padding: "10px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>Orange Navel x85</td>
                    <td style={{ fontSize: "16px", textAlign: "right", padding: "10px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>2</td>
                    <td style={{ fontSize: "16px", textAlign: "right", padding: "10px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }} />
                    <td style={{ fontSize: "16px", textAlign: "right", padding: "10px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }} />
                    <td style={{ fontSize: "16px", textAlign: "right", padding: "10px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }} />
                  </tr> */}
                      {/* <tr>
                        <td colSpan={7} style={{ fontSize: "12px", textAlign: "right", padding: "10px 4px 5px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>
                          {`Item Count: ${ele.TotalProducts}`}
                        </td>
                      </tr> */}
                      <tr><td>
                        <div style={{ height: calculateSpace(firstPageRows, otherPagesRows, 5, ele.products.length) }}>

                        </div>
                      </td>
                      </tr>
                      <tr>
                        <td colSpan={7}>
                          <div style={{ display: "flex", width: "100%", gap: "10px", marginTop: "8px" }}>
                            <div style={{ width: "30%" }}>
                              <div style={{ display: "flex", fontSize: "8px", justifyContent: "space-between" }}>
                                <div style={{ fontWeight: "bold", textDecoration: "underline" }}>UNITED</div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                  <div style={{ fontWeight: "bold" }}>8</div>
                                  <div style={{ border: "1px solid", minHeight: "20px", width: "50px", fontSize: "6px", marginLeft: "10px" }}>
                                  </div>
                                </div>
                              </div>

                              <div style={{ display: "flex", fontSize: "8px", marginTop: "8px", justifyContent: "space-between" }}>
                                <div style={{ fontWeight: "bold", textDecoration: "underline" }}>WA&nbsp;CRATE</div>
                                <div>
                                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ fontWeight: "bold" }}>22</div>
                                    <div style={{ border: "1px solid", minHeight: "20px", width: "50px", fontSize: "6px", marginLeft: "10px" }}>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "2px" }}>
                                    <div style={{ fontWeight: "bold" }}>36</div>
                                    <div style={{ border: "1px solid", minHeight: "20px", width: "50px", fontSize: "6px", marginLeft: "10px" }}>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "2px" }}>
                                    <div style={{ fontWeight: "bold" }}>84</div>
                                    <div style={{ border: "1px solid", minHeight: "20px", width: "50px", fontSize: "6px", marginLeft: "10px" }}>
                                    </div>
                                  </div>

                                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "2px" }}>
                                    <div style={{ fontWeight: "bold" }}>Bin</div>
                                    <div style={{ border: "1px solid", minHeight: "20px", width: "50px", fontSize: "6px", marginLeft: "10px" }}>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div style={{ display: "flex", fontSize: "8px", marginTop: "8px", justifyContent: "space-between" }}>
                                <div style={{ fontWeight: "bold", textDecoration: "underline" }}>OTHER</div>
                                <div>
                                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ fontWeight: "bold" }}>M8</div>
                                    <div style={{ border: "1px solid", minHeight: "20px", width: "50px", fontSize: "6px", marginLeft: "10px" }}>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "2px" }}>
                                    <div style={{ fontWeight: "bold" }}>Pallets</div>
                                    <div style={{ border: "1px solid", minHeight: "20px", width: "50px", fontSize: "6px", marginLeft: "10px" }}>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                            <div style={{ width: "70%", fontSize: "8px", }}>
                              <div style={{ display: "flex", width: "100%", gap: "10px" }}>
                                <div>
                                  <div style={{ fontWeight: "bold" }}>Order Notes</div>
                                  <div style={{ border: "1px solid", minHeight: "35px", marginTop: "8px", padding: "4px", marginBottom: "12px", width: "180px", fontSize: "6px" }}>
                                    {ele?.OrderNotes || ""}
                                  </div>
                                </div>
                                <div style={{ display: "flex", width: "180px", justifyContent: "center" }}>
                                  <div style={{ fontWeight: "bold" }}>{`Item Count: ${ele.TotalProducts}`}</div>
                                </div>
                              </div>
                              <div style={{ display: "flex", width: "100%", gap: "10px" }}>
                                <div>
                                  <div style={{ fontWeight: "bold" }}>Delivery Instructions</div>
                                  <div style={{ border: "1px solid", minHeight: "35px", marginTop: "8px", padding: "4px", width: "180px", fontSize: "6px" }}>
                                    {ele?.DeliveryInstructions || ""}
                                  </div>
                                </div>

                                <div>
                                  <div style={{ fontWeight: "bold" }}>Print Name</div>
                                  <div style={{ border: "1px solid", minHeight: "35px", marginTop: "8px", padding: "4px", width: "180px", fontSize: "6px" }}>
                                    {ele?.PrintOrder || ""}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ position: "absolute", bottom: 0, display: "flex", width: "100vw", borderBottom: "1px solid #787A80" }}>
          <div style={{ padding: "0px 120px 5px 20px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>{moment().format("dddd, MMMM Do, YYYY")}</div>
          <div style={{ padding: "0px 140px 5px 10px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>VISION PRODUCE</div>
          <div style={{ padding: "0px 10px 5px 30px", fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</div>
        </div>
      </>
    )
  })

  // await pdf.html(ReactDOMServer.renderToString(element), {
  //   // html2canvas: { scale:  },
  //   callback: function (doc) {
  //     // window.open(doc.output('bloburl'));
  //     //  doc.save('sample.pdf');
  //     if (!preview) {
  //       doc.autoPrint({ variant: 'non-conform' })
  //     }
  //     doc.output('dataurlnewwindow');
  //   },
  //   // autoPaging:"text"
  // });
  await generateAndDownloadPdf(element, preview, 'p');
}

export const printPriceList = async (priceListData) => {
  const firstPageRows = 22;
  const otherPagesRows = 28;
  const totalPageCount = getTotalPages(firstPageRows, otherPagesRows, priceListData, true);
  let currentPage = 0;
  const element = priceListData.map((ele, index) => {
    const currentTotalPage = getTotalPages(firstPageRows, otherPagesRows, [priceListData[index]], true);
    let currentPageRow = 0;
    let startPage = 1;
    currentPage += 1;
    return (
      <>
        <div className="element-to-print" style={{ height: `${currentTotalPage * 830}px` }}>
          <table
            width="100%"
            cellSpacing={0}
            cellPadding={0}
            bgcolor="ffffff"
            border={0}
          >
            <tbody>
              <tr>
                <td>
                  <table
                    // width="100%"
                    width="600px"
                    cellSpacing={0}
                    cellPadding={0}
                    border={0}
                    style={{ padding: "5px 20px" }}
                  >
                    <tbody>
                      <tr>
                        <td>
                          <img
                            src={visionLogo}
                            alt=""
                            width={170}
                            height={40}
                          />
                        </td>
                        <td
                          style={{
                            // fontFamily: "Outfit",
                            fontWeight: 600,
                            fontSize: 20,
                            textAlign: "right"
                          }}
                        >Price List - Vision</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table
                    width="100%"
                    cellSpacing={0}
                    cellPadding={0}
                    border={0}
                    style={{ padding: "12px 25px", backgroundColor: "#fff" }}
                  >
                    <tbody>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing={0} cellPadding={0} border={0}>
                            <tbody>
                              <tr>
                                <td
                                  width="50%"
                                  style={{
                                    fontSize: 14,
                                    color: "#787A80",
                                    fontWeight: 500,
                                    textAlign: "left"
                                  }}
                                >
                                  Customer: {ele.CustomerCode}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <table width="100%" cellSpacing={0} cellPadding={0} border={0}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    width: "50%",
                                    fontSize: 14,
                                    color: "#787A80",
                                    fontWeight: 500,
                                    textAlign: "right"
                                  }}
                                >
                                  Date: {moment(ele.OrderDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <table
                    width="100%"
                    cellSpacing={4}
                    cellPadding={0}
                    style={{ padding: 25 }}
                  >
                    <thead>
                      <tr>
                        <td style={{ fontSize: "14px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }} colSpan={2}>Vision Produce</td>
                        <td style={{ fontSize: "14px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }}>Qty</td>
                        <td style={{ fontSize: "14px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }}>Crate</td>
                        <td style={{ fontSize: "14px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }}>Count</td>
                        <td style={{ fontSize: "14px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }}>Price</td>
                      </tr>
                    </thead>
                    <tbody>
                      {ele.products.map((product, productIndex) => {
                        let rows = [];
                        if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                          currentPage += 1;
                          startPage += 1;
                          currentPageRow = 0;
                        }
                        currentPageRow += 1;
                        rows.push(
                          <>
                            <tr style={{ height: "25px" }}>
                              <td style={{ fontSize: "14px", textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{`${product.Qty} ${product.UnitName}`}</td>
                              <td style={{ fontSize: "14px", textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.ProductName}</td>
                              <td style={{ fontSize: "14px", textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.Qty}</td>
                              <td style={{ fontSize: "14px", textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.ContainerName}</td>
                              <td style={{ fontSize: "14px", textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.Count}</td>
                              <td style={{ fontSize: "14px", textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{formatAmount(product.SellPrice)}</td>
                            </tr>
                            {currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0 && (
                              <tr style={{ height: "60px" }}>
                                <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                              </tr>
                            )}
                          </>)
                        if (productIndex === ele.products.length - 1 && ((ele.products.length - firstPageRows) % firstPageRows === 0 || (ele.products.length - firstPageRows) % otherPagesRows === 0)) {
                          currentPage += 1;
                        }
                        return rows;
                      })}

                      <tr>
                        <td colSpan={7} style={{ fontSize: "16px", textAlign: "right", padding: "10px 4px 5px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>
                          {`Item Count: ${ele.products.length}`}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ position: "absolute", bottom: 0, display: "flex", width: "100vw", borderBottom: "1px solid #787A80" }}>
          <div style={{ padding: "0px 120px 5px 20px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>{moment().format("dddd, MMMM Do, YYYY")}</div>
          <div style={{ padding: "0px 140px 5px 10px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>VISION PRODUCE</div>
          <div style={{ padding: "0px 10px 5px 30px", fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</div>
        </div>
      </>
    )
  })
  await generateAndDownloadPdf(element, true, 'p');
}

export const printInvoice = async (invoiceData) => {
  const fileName = `Vision Product Invoice ${invoiceData?.InvoiceNo}_${invoiceData?.tblCustomer?.CustomerCode}`
  let crateDeposit = 0;
  let crateHireFee = 0;
  let crateHireGST = 0;
  let subTotal = 0;
  let totalGST = 0;
  const cratesDetails = await calculateCrates(invoiceData?.tblOrderDetails);
  let crateTotal = 0;
  let lessRebate = 0;
  const showRRP = invoiceData?.tblCustomer?.RRP ? true : false;
  const element =
    <div style={{ height: "840px" }}>
      <div className="element-to-print" style={{ width: "580px" }}>
        <table
          width="100%"
          cellSpacing={0}
          cellPadding={0}
          bgcolor="ffffff"
          border={0}
        >
          <tbody>
            <tr>
              <td>
                <table
                  width="100%"
                  cellSpacing={0}
                  cellPadding={0}
                  border={0}
                  style={{ padding: "15px 10px 0px 10px" }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          fontWeight: 700,
                          fontSize: 22,
                          textAlign: "left",
                          fontFamily: "primary",
                          paddingLeft: "25px"
                        }}
                      >TAX INVOICE</td>
                      <td style={{ textAlign: "end" }}>
                        <img
                          src={visionLogo}
                          alt=""
                          width={220}
                          height={60}
                          style={{
                            textAlign: "right"
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table
                  width="100%"
                  cellSpacing={0}
                  cellPadding={0}
                  border={0}
                  style={{ backgroundColor: "#fff" }}
                >
                  <tbody>
                    <tr>
                      <td>
                        <table width="100%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 0px 5px 35px" }}>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  textAlign: "left"
                                }}
                              >
                                {invoiceData.tblCustomer?.CustomerName}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  textAlign: "left"
                                }}
                              >
                                {invoiceData.tblCustomer?.InvoiceAddress1 || invoiceData.tblCustomer?.InvoiceAddress2 || invoiceData.tblCustomer?.InvoiceAddress3}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  textAlign: "left"
                                }}
                              >
                                {invoiceData.tblCustomer?.InvoicePostCode}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <table width="100%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 5px 5px 0px" }}>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  textAlign: "right"
                                }}
                              >
                                Invoice No :
                              </td>
                              <td
                                style={{
                                  fontSize: "10px",
                                  textAlign: "right"
                                }}
                              >
                                {invoiceData.InvoiceNo}
                              </td>
                              <td
                                style={{
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  textAlign: "right"
                                }}
                              >
                                Date :
                              </td>
                              <td
                                style={{
                                  fontSize: "10px",
                                  textAlign: "left",
                                  paddingLeft: "10px"
                                }}
                              >
                                {moment(invoiceData.InvoiceDate, "YYYY-MM-DD").format("MM/DD/YYYY")}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  textAlign: "right"
                                }}
                              >
                                Code :
                              </td>
                              <td
                                style={{
                                  fontSize: "10px",
                                  textAlign: "right"
                                }}
                              >
                                {invoiceData.tblCustomer?.CustomerCode}
                              </td>
                              <td
                                style={{
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  textAlign: "right"
                                }}
                              >
                                PO :
                              </td>
                              <td
                                style={{
                                  fontSize: "10px",
                                  textAlign: "left",
                                  paddingLeft: "10px"
                                }}
                              >
                                {invoiceData.PurchaseOrder}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table
                  width="100%"
                  cellSpacing={0}
                  cellPadding={0}
                  style={{ padding: "15px 25px 0px 25px" }}
                >
                  <tr>
                    <td style={{ fontSize: "10px", fontWeight: "700", textAlign: "left", paddingLeft: "10px" }}>Delivery &nbsp; Instructions  &nbsp;  : &nbsp;  {invoiceData.DeliveryInstructions}</td>
                  </tr>
                  <tr>
                    <td colSpan={8} style={{ fontWeight: "700", paddingTop: "4px", borderBottom: "2px solid" }}></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table
                  width="100%"
                  cellSpacing={4}
                  cellPadding={0}
                  style={{ padding: "2px 25px" }}
                >
                  <thead>
                    <tr>
                      <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Code</td>
                      <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Qty</td>
                      <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "left", padding: "4px 4px", width: "8%" }}>Type</td>
                      <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "left", padding: "4px 4px", width: "35%" }}>Product&nbsp; Details</td>
                      <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", width: "6%" }}>Cnt &nbsp;/Wt</td>
                      {showRRP && <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>RRP</td>}
                      <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Unit Price</td>
                      <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Value</td>
                      <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>GST</td>
                    </tr>
                    <tr>
                      <td colSpan={9} style={{ color: "#1F222C", borderBottom: "2px solid" }}></td>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceData?.tblOrderDetails?.map((product, productIndex) => {
                      let rows = [];
                      crateDeposit += product.CrateValue;
                      crateHireFee += product.CrateHire;
                      crateHireGST += product.CrateGST;
                      subTotal += product.ExtSell;
                      totalGST += product.GSTAmount;
                      lessRebate = subTotal * (invoiceData.tblCustomer?.StandardRebate / 100)
                      let lineText = product.Qty == 0 ? "NOT AVAILABLE" : product.SellPrice == 0 && product.ExtSell == 0 ? "NO CHARGE" : ""
                      // if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                      //   currentPage += 1;
                      //   startPage += 1;
                      //   currentPageRow = 0;
                      // }
                      // currentPageRow += 1;
                      rows.push(
                        <>
                          <tr style={{ lineHeight: 0.5 }}>
                            <td style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{product.tblProduct?.ProductCode || product.ProductCode}</td>
                            <td style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{product.Qty}</td>
                            <td style={{ fontSize: "10px", textAlign: "left", padding: "2px 4px", fontWeight: 500 }}>{product.tblContainer?.TypeInCode}</td>
                            <td style={{ fontSize: "10px", textAlign: "left", padding: "2px 4px", fontWeight: 500 }}>{`${product.ProductName} ${product.ClassName || ''} ${product.SizeName || ''}`}</td>

                            {!lineText ? <>
                              <td style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{product.Count || 0}</td>
                              {showRRP && <td style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{product.RRP || 0}</td>}
                              <td style={{ fontSize: "10px", textAlign: "right", padding: "2px 4px", fontWeight: 500 }}>{formatAmount(product.SellPrice)}</td>
                              <td style={{ fontSize: "10px", textAlign: "right", padding: "2px 4px", fontWeight: 500 }}>{formatAmount(product.ExtSell)}</td>
                              <td style={{ fontSize: "10px", textAlign: "right", padding: "2px 4px", fontWeight: 500 }}>{formatAmount(product.GSTAmount)}</td>
                            </> : <>
                              <td colSpan={showRRP ? 5 : 4} style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{lineText}</td>
                            </>}
                          </tr>
                          {/* {currentPageRow !== 0 && currentPageRow % (startPage === 1? firstPageRows : otherPagesRows) === 0 && (
                    <tr style={{ height: "60px" }}>
                      <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                    </tr>
                  )} */}
                        </>)
                      // if (productIndex === ele.products.length - 1 && ((ele.products.length - firstPageRows) % firstPageRows === 0 || (ele.products.length - firstPageRows) % otherPagesRows === 0)) {
                      //   currentPage += 1;
                      // }
                      return rows;
                    })}
                    <tr>
                      <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid" }}></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
      <div style={{ display: "flex", padding: "2px 25px 40px 35px", width: "580px" }}>
        <div style={{ width: "160px" }}>
          {cratesDetails && <>
            <div style={{ fontSize: "12px", padding: "2px", fontWeight: 700, backgroundColor: "#D3D3D3" }}>
              <span>Crate Summary</span>
            </div>
            <div>
              <table
                width="100%"
                cellSpacing={4}
                cellPadding={0}
                style={{ fontSize: "8px" }}
              >
                {Object.keys(cratesDetails).map((key) => {
                  let crateItem = cratesDetails[key];
                  crateTotal += crateItem.totalPrice
                  return (
                    <tr>
                      <td style={{ textAlign: "left" }}>{crateItem.description}</td>
                      <td style={{ textAlign: "left" }}>{crateItem.qty}</td>
                      <td style={{ textAlign: "right" }}>{crateItem.label}</td>
                      <td style={{ textAlign: "right", paddingBottom: "4px" }}>{formatAmount(crateItem.totalPrice)}</td>
                    </tr>
                  )
                })}
                <tr>
                  <td colSpan={4} style={{ fontSize: "8px", fontWeight: "700", color: "#1F222C", textAlign: "center", borderBottom: "1px solid" }}></td>
                </tr>
                <tr>
                  <td colSpan={3} style={{ fontSize: "8px", textAlign: "right", padding: "0px 4px", fontWeight: 800, }}>Crate Total &nbsp;: </td>
                  <td style={{ fontSize: "10px", textAlign: "right", fontWeight: 800 }}>{formatAmount(crateTotal)}</td>
                </tr>
              </table>
            </div>
          </>
          }
        </div>
        <div style={{ width: "300px", marginLeft: "60px" }}>
          <table
            width="100%"
            cellSpacing={4}
            cellPadding={0}
            style={{ fontSize: "8px" }}
          >
            <tr>
              <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>Produce&nbsp; Subtotal &nbsp;: </td>
              <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(subTotal)}</td>
              <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(totalGST)}</td>
            </tr>
            {invoiceData.tblCustomer?.StandardRebate != 0 &&
              <>
                <tr>
                  <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>Less Produce&nbsp; Rebate at {invoiceData.tblCustomer?.StandardRebate}% &nbsp;: </td>
                  <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(lessRebate)}</td>
                </tr>
                <tr>
                  <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>Produce&nbsp; Total &nbsp;: </td>
                  <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>{formatAmount(subTotal - lessRebate)}</td>
                </tr>
              </>
            }
            <tr>
              <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "10px" }}>Plus Crate Deposit &nbsp;: </td>
              <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "10px" }}>{formatAmount(crateDeposit - crateHireFee)}</td>
            </tr>
            <tr>
              <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "4px" }}>Plus Crate Hire Fee &nbsp;: </td>
              <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "4px" }}>{formatAmount(crateHireFee)}</td>
            </tr>
            <tr>
              <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "4px" }}>Plus Crate Hire GST &nbsp;: </td>
              <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "4px" }}>{formatAmount(crateHireGST)}</td>
            </tr>
            <tr>
              <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid", paddingTop: "4px" }}></td>
            </tr>
            <tr style={{ fontSize: "10px", fontWeight: 700 }}>
              <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>INVOICE &nbsp;TOTAL &nbsp;(inc GST) &nbsp;:</td>
              <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>{formatAmount((subTotal - lessRebate) + crateDeposit + crateHireGST)}</td>
            </tr>
            <tr>
              <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", width: "20px", borderBottom: "2px solid" }}></td>
            </tr>
          </table>
        </div>
      </div>
      <div style={{ position: "absolute", bottom: 0, width: "580px" }}>
        <div style={{ fontWeight: "700", color: "#1F222C", borderBottom: "2px solid", margin: "0px 25px 5px 25px" }}></div>
        <div className='d-flex'>
          <div className='' style={{ width: "300px", textAlign: "justify", fontSize: "8px", paddingLeft: "30px" }}>

            <div style={{ paddingBottom: "8px", fontWeight: "700" }}>
              Where produce is marked with an Asterisk (*), the item attracts GST and
              the GST amount is shown. Items without an asterisk are GST exempt.
            </div>

            <div className='pb-2' style={{ fontWeight: "700" }}>All Claims for credit must be received within 24 hours of receipt of goods.</div>

            <div className='pb-2'>Where the Sell Price is red and/or bold, your price has gone up since the last time you
              ordered this product.</div>

            <div className='pb-2'>Where the Sell Price is green and/or underlined, your price has gone down since the last
              time you ordered this product.</div>

            <div className='pb-2'>*All products are Australian grown unless specified on our invoice.</div>
          </div>
          <div style={{ width: "100px" }}></div>
          <div style={{ width: "180px", textAlign: "justify", fontSize: "8px", paddingTop: "30px", lineHeight: "12px" }}>
            {/* <div style={{position:"absolute", right:"200px", bottom:"50px"}}>Page 1 of 1</div> */}
            <div style={{ fontWeight: "700" }}>Vision Produce Pty Ltd </div>
            ABN 11 098 952 768  <br />
            Mail Point 103, Market City,  <br />
            280 Bannister Road  <br />
            Canning Vale WA 6155  <br />
            Telephone: (08) 9456 5953  <br />
            Facsimile: (08) 9456 5948  <br />
            E-mail: accounts@visionproduce.com.au
          </div>
        </div>
      </div>
    </div>

  await generateAndDownloadPdf([element], true, 'p', true, fileName);
}

export const calculateCrates = async (details) => {
  let cratesItems = {};

  details.forEach(detail => {
    let crate = detail.tblContainer;
    if (crate) {
      if (!cratesItems[crate.ContainerID]) {
        cratesItems[crate.ContainerID] = {
          label: crate.TypeInCode,
          qty: 0,
          totalPrice: 0,
          description: crate.ContainerDesc
        };
      }
      cratesItems[crate.ContainerID].qty += parseInt(detail.Qty);
      cratesItems[crate.ContainerID].totalPrice += detail.Qty * crate.ContainerValue;
    }
  });

  return cratesItems;
}

export const printCrateCredit = async (creditData) => {
  const firstPageRows = 50;
  const otherPagesRows = 56;
  let tempCreditData = Object.assign({}, creditData);
  tempCreditData.products = creditData.creditDetails;
  const totalPageCount = getTotalPages(firstPageRows, otherPagesRows, [tempCreditData], true);
  let currentPage = 0;
  const mainPageHeight = totalPageCount * 840.5;
  let currentPageRow = 0;
  let startPage = 1;
  currentPage += 1;
  let subTotal = 0;
  let totalQty = 0;
  const element = <div style={{ height: `${mainPageHeight}px` }}>
    <div className="element-to-print" style={{ width: "580px" }}>
      <table
        width="100%"
        cellSpacing={0}
        cellPadding={0}
        bgcolor="ffffff"
        border={0}
      >
        <tbody>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={0}
                cellPadding={0}
                border={0}
                style={{ padding: "15px 10px 0px 10px" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontWeight: 700,
                        fontSize: 22,
                        textAlign: "left",
                        fontFamily: "primary",
                        paddingLeft: "25px"
                      }}
                    >Credit Note</td>
                    <td style={{ textAlign: "end" }}>
                      <img
                        src={visionLogo}
                        alt=""
                        width={220}
                        height={60}
                        style={{
                          textAlign: "right"
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={0}
                cellPadding={0}
                border={0}
                style={{ backgroundColor: "#fff" }}
              >
                <tbody>
                  <tr>
                    <td>
                      <table width="50%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 0px 5px 35px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.CustomerName}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.InvoiceAddress1 || creditData.tblCustomer?.InvoiceAddress2 || creditData.tblCustomer?.InvoiceAddress3}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.InvoicePostCode}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <table width="100%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 5px 5px 0px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "right"
                              }}
                            >
                              Credit Note :
                            </td>
                            <td
                              style={{
                                fontSize: "10px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {creditData?.CNID}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "right",
                              }}
                            >
                              Date :
                            </td>
                            <td
                              style={{
                                fontSize: "10px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {moment(creditData?.ReturnDate, "YYYY-MM-DD").format("MM/DD/YYYY")}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "right",
                              }}
                            >
                              Code :
                            </td>
                            <td
                              style={{
                                fontSize: "10px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {creditData.tblCustomer?.CustomerCode}
                            </td>

                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={4}
                cellPadding={0}
                style={{ padding: "2px 25px" }}
              >
                <thead>
                  <tr>
                    <td colSpan={8} style={{ fontWeight: "700", paddingTop: "4px", borderBottom: "2px solid" }}></td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Qty</td>
                    <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "left", padding: "4px 4px", width: "35%" }}>Details</td>
                    <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "right", padding: "4px 4px" }}>Value</td>
                  </tr>
                  <tr>
                    <td colSpan={8} style={{ color: "#1F222C", borderBottom: "2px solid" }}></td>
                  </tr>
                </thead>
                <tbody>
                  {creditData?.creditDetails?.map((creditItem, creditIndex) => {
                    let rows = [];
                    subTotal += creditItem.CrateCreditAmt ? parseFloat(creditItem.CrateCreditAmt) : 0;
                    totalQty += creditItem.Qty ? parseInt(creditItem.Qty) : 0;
                    if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                      currentPage += 1;
                      startPage += 1;
                      currentPageRow = 0;
                    }
                    currentPageRow += 1;
                    rows.push(
                      <>
                        <tr style={{ lineHeight: 0.5 }}>
                          <td style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{creditItem.Qty}</td>
                          <td style={{ fontSize: "10px", textAlign: "left", padding: "2px 4px", fontWeight: 500 }}>{creditData?.crates?.find(crate => crate.ContainerID == creditItem.ContainerID)?.label || ''}</td>
                          <td style={{ fontSize: "10px", textAlign: "right", padding: "2px 4px", fontWeight: 500 }}>{formatAmount(creditItem.CrateCreditAmt)}</td>
                        </tr>
                        {currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0 && (
                          <tr style={{ height: "60px" }}>
                            <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                          </tr>
                        )}
                      </>)
                    if (creditIndex === creditData?.creditDetails.length - 1 && ((creditData?.creditDetails.length - firstPageRows) % firstPageRows === 0 || (creditData?.creditDetails.length - firstPageRows) % otherPagesRows === 0)) {
                      currentPage += 1;
                    }
                    return rows;
                  })}
                  <tr>
                    <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid" }}></td>
                  </tr>
                  <tr style={{ lineHeight: 0.5 }}>
                    <td style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 700 }}>{totalQty}</td>
                    <td colSpan={3} style={{ fontSize: "10px", textAlign: "right", padding: "2px 4px", fontWeight: 700 }}>Subtotal &nbsp;:&nbsp;&nbsp;{formatAmount(subTotal)}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end", padding: "60px 25px 40px 35px", width: "580px" }}>
      <table
        width="50%"
        cellSpacing={4}
        cellPadding={0}
        align="right"
        style={{ fontSize: "8px" }}
      >
        {/* {creditData.tblCustomer?.StandardRebate &&
            <>
              <tr>
                <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>Less Produce&nbsp; Rebate at {invoiceData.tblCustomer?.StandardRebate}% &nbsp;: </td>
                <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(lessRebate)}</td>
              </tr>
              <tr>
                <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>Produce&nbsp; Total &nbsp;: </td>
                <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>{formatAmount(subTotal - lessRebate)}</td>
              </tr>
            </>
          } */}

        <tr>
          <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid", paddingTop: "4px" }}></td>
        </tr>
        <tr style={{ fontSize: "10px", fontWeight: 700 }}>
          <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>TOTAL &nbsp;:</td>
          <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>{formatAmount(subTotal)}</td>
        </tr>
        <tr>
          <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", width: "20px", borderBottom: "2px solid" }}></td>
        </tr>
      </table>
    </div>
    <div style={{ position: "absolute", bottom: 0, width: "580px" }}>
      <div style={{ fontWeight: "700", color: "#1F222C", borderBottom: "2px solid", margin: "0px 25px 5px 25px" }}></div>
      <div className='d-flex justify-content-end'>
        <div style={{ width: "180px", textAlign: "justify", fontSize: "8px", paddingTop: "10px", paddingBottom: "10px", lineHeight: "12px" }}>
          <div style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "30px" }}>{`Page ${currentPage} of ${totalPageCount}`}</div>
          <div style={{ fontWeight: "700" }}>Vision Produce Pty Ltd </div>
          ABN 11 098 952 768  <br />
          Mail Point 103, Market City,  <br />
          280 Bannister Road  <br />
          Canning Vale WA 6155  <br />
          Telephone: (08) 9456 5953  <br />
          Facsimile: (08) 9456 5948  <br />
          E-mail: accounts@visionproduce.com.au
        </div>
      </div>
    </div>
  </div>

  await generateAndDownloadPdf([element], true, 'p', false, '');
}

export const printProductCredit = async (creditData) => {
  const firstPageRows = 50;
  const otherPagesRows = 56;
  let tempCreditData = Object.assign({}, creditData);
  tempCreditData.products = creditData.creditDetails;
  const totalPageCount = getTotalPages(firstPageRows, otherPagesRows, [tempCreditData], true);
  let currentPage = 0;
  const mainPageHeight = totalPageCount * 840.5;
  let currentPageRow = 0;
  let startPage = 1;
  currentPage += 1;
  let subTotal = 0;
  let totalQty = 0;
  const element = <div style={{ height: `${mainPageHeight}px` }}>
    <div className="element-to-print" style={{ width: "580px" }}>
      <table
        width="100%"
        cellSpacing={0}
        cellPadding={0}
        bgcolor="ffffff"
        border={0}
      >
        <tbody>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={0}
                cellPadding={0}
                border={0}
                style={{ padding: "15px 10px 0px 10px" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontWeight: 700,
                        fontSize: 22,
                        textAlign: "left",
                        fontFamily: "primary",
                        paddingLeft: "25px"
                      }}
                    >Credit Note</td>
                    <td style={{ textAlign: "end" }}>
                      <img
                        src={visionLogo}
                        alt=""
                        width={220}
                        height={60}
                        style={{
                          textAlign: "right"
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={0}
                cellPadding={0}
                border={0}
                style={{ backgroundColor: "#fff" }}
              >
                <tbody>
                  <tr>
                    <td>
                      <table width="50%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 0px 5px 35px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.CustomerName}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.InvoiceAddress1 || creditData.tblCustomer?.InvoiceAddress2 || creditData.tblCustomer?.InvoiceAddress3}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.InvoicePostCode}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <table width="100%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 5px 5px 0px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "right"
                              }}
                            >
                              Credit Note :
                            </td>
                            <td
                              style={{
                                fontSize: "10px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {creditData?.CNID}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "right",
                              }}
                            >
                              Date :
                            </td>
                            <td
                              style={{
                                fontSize: "10px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {moment(creditData?.ReturnDate, "YYYY-MM-DD").format("MM/DD/YYYY")}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "10px",
                                fontWeight: 700,
                                textAlign: "right",
                              }}
                            >
                              Code :
                            </td>
                            <td
                              style={{
                                fontSize: "10px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {creditData.tblCustomer?.CustomerCode}
                            </td>

                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={4}
                cellPadding={0}
                style={{ padding: "2px 25px" }}
              >
                <thead>
                  <tr>
                    <td colSpan={8} style={{ fontWeight: "700", paddingTop: "4px", borderBottom: "2px solid" }}></td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Qty</td>
                    <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "left", padding: "4px 4px", width: "35%" }}>Details</td>
                    <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "right", padding: "4px 4px" }}>Value</td>
                  </tr>
                  <tr>
                    <td colSpan={8} style={{ color: "#1F222C", borderBottom: "2px solid" }}></td>
                  </tr>
                </thead>
                <tbody>
                  {creditData?.creditDetails?.map((creditItem, creditIndex) => {
                    let rows = [];
                    subTotal += creditItem.ProdCreditAmt ? parseFloat(creditItem.ProdCreditAmt) : 0;
                    totalQty += creditItem.Qty ? parseInt(creditItem.Qty) : 0;
                    if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                      currentPage += 1;
                      startPage += 1;
                      currentPageRow = 0;
                    }
                    currentPageRow += 1;
                    rows.push(
                      <>
                        <tr style={{ lineHeight: 0.5 }}>
                          <td style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{creditItem.Qty}</td>
                          <td style={{ fontSize: "10px", textAlign: "left", padding: "2px 4px", fontWeight: 500 }}>
                            {creditData?.units?.find(unit => unit.value == creditItem.UnitID)?.label || ''}&nbsp;&nbsp;
                            {creditData?.products?.find(product => product.value == creditItem.ProductID)?.productName || ''}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "right", padding: "2px 4px", fontWeight: 500 }}>{formatAmount(creditItem.ProdCreditAmt)}</td>
                        </tr>
                        {creditIndex === creditData.creditDetails.length - 1 && (<>
                          <tr>
                            <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid" }}></td>
                          </tr>
                          <tr style={{ lineHeight: 0.5 }}>
                            <td style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 700 }}>{totalQty}</td>
                            <td colSpan={3} style={{ fontSize: "10px", textAlign: "right", padding: "2px 4px", fontWeight: 700 }}>Subtotal &nbsp;:&nbsp;&nbsp;{formatAmount(subTotal)}</td>
                          </tr></>
                        )}
                        {currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0 && (
                          <tr style={{ height: "60px", border: "1px solid red" }}>
                            <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                          </tr>
                        )}
                      </>)
                    if (creditIndex === creditData.creditDetails.length - 1 && ((creditData.creditDetails.length - firstPageRows) % firstPageRows === 0 || (creditData.creditDetails.length - firstPageRows) % otherPagesRows === 0)) {
                      currentPage += 1;
                    }
                    return rows;
                  })}

                </tbody>
              </table>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end", padding: "60px 25px 40px 35px", width: "580px" }}>
      <table
        width="50%"
        cellSpacing={4}
        cellPadding={0}
        align="right"
        style={{ fontSize: "8px" }}
      >
        {/* {creditData.tblCustomer?.StandardRebate &&
            <>
              <tr>
                <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>Less Produce&nbsp; Rebate at {invoiceData.tblCustomer?.StandardRebate}% &nbsp;: </td>
                <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(lessRebate)}</td>
              </tr>
              <tr>
                <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>Produce&nbsp; Total &nbsp;: </td>
                <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>{formatAmount(subTotal - lessRebate)}</td>
              </tr>
            </>
          } */}

        <tr>
          <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid", paddingTop: "4px" }}></td>
        </tr>
        <tr style={{ fontSize: "10px", fontWeight: 700 }}>
          <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>TOTAL &nbsp;:</td>
          <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>{formatAmount(subTotal)}</td>
        </tr>
        <tr>
          <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", width: "20px", borderBottom: "2px solid" }}></td>
        </tr>
      </table>
    </div>
    <div style={{ position: "absolute", bottom: 0, width: "580px" }}>
      <div style={{ fontWeight: "700", color: "#1F222C", borderBottom: "2px solid", margin: "0px 25px 5px 25px" }}></div>
      <div className='d-flex justify-content-end'>
        <div style={{ width: "180px", textAlign: "justify", fontSize: "8px", paddingTop: "10px", paddingBottom: "10px", lineHeight: "12px" }}>
          <div style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "30px" }}>{`Page ${currentPage} of ${totalPageCount}`}</div>
          <div style={{ fontWeight: "700" }}>Vision Produce Pty Ltd </div>
          ABN 11 098 952 768  <br />
          Mail Point 103, Market City,  <br />
          280 Bannister Road  <br />
          Canning Vale WA 6155  <br />
          Telephone: (08) 9456 5953  <br />
          Facsimile: (08) 9456 5948  <br />
          E-mail: accounts@visionproduce.com.au
        </div>
      </div>
    </div>
  </div>

  await generateAndDownloadPdf([element], true, 'p', false, '');
}

const printProductSheetAll = async (preview = false) => {
  const firstPageRows = 26;
  const otherPagesRows = 32;
  const totalPageCount = getTotalPages(firstPageRows, otherPagesRows, buyingSheetData, false);
  let currentPage = 0;
  const element = buyingSheetData.map((item, index) => {
    const currentTotalPage = getTotalPages(firstPageRows, otherPagesRows, [buyingSheetData[index]], false);
    let currentPageRow = 0;
    let startPage = 1;
    currentPage += 1;
    return (
      <>
        <div className="element-to-print" style={{ height: `${currentTotalPage * 820}px` }}>
          <table className="test" width="100%" cellSpacing="0" cellPadding="0" bgcolor="f1f1f1" border="0" >
            <tbody>
              <tr>
                <td>
                  <table width="600px" cellSpacing="0" cellPadding="0" align="center" bgcolor="#fff" border="0" >
                    <tbody>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "20px 25px" }}>
                            <tbody>  <tr>
                              <td>
                                <img src={visionLogo} alt="" width="170" height="40" />
                              </td>
                              <td style={{ fontFamily: 'Outfit', fontWeight: "bold", fontSize: "18px", textAlign: "right" }}>
                                Purchase Order - Vision
                              </td>
                            </tr> </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "12px 25px", backgroundColor: "#F8F8F8" }}>
                            <tbody>
                              <tr>
                                <td>
                                  <table width="100%" cellSpacing="0" cellPadding="0" border="0">
                                    <tbody>
                                      <tr>
                                        <td width="14%" style={{ fontSize: "12px", color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "4px"}}>Agent: </td>
                                        <td style={{ fontSize: "12px", color: "#1F222C", fontWeight: 500 }}>{item.agentCode}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <table width="100%" cellSpacing="0" cellPadding="0" border="0">
                                    <tbody>
                                      <tr>
                                        <td style={{ fontSize: "12px", color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "4px" }}>Date:</td>
                                        <td width="30%" style={{ fontSize: "12px", color: "#1F222C", fontWeight: "500" }}>{moment(fromDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table className="product-table" width="100%" align="center" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "25px 25px 15px 25px" }}>
                            <thead>
                              <tr>
                                <td style={{
                                  fontSize: "14px", fontWeight: 500,
                                  color: "#787A80", width: "140px", textAlign: "center"
                                }}>Products</td>
                                <td style={{ padding: "12px" }}>Ttl</td>
                              </tr>
                            </thead>
                            <tbody>
                              {item.products.map((product, productIndex) => {
                                let rows = [];
                                if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                                  currentPage += 1;
                                  startPage += 1;
                                  currentPageRow = 0;
                                }
                                currentPageRow += 1;
                                rows.push(<tr key={productIndex}>
                                  <td style={{ textAlign: "center" }}>{product.ProductName}</td>
                                  <td style={{ textAlign: "center" }}>{product.TotalQty}</td>
                                  {productIndex !== item.products.length - 1 && currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0 && (
                                    <tr style={{ height: "60px" }}>
                                      <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                                    </tr>
                                  )}
                                </tr>)
                                return rows;
                              })}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ position: "absolute", bottom: 0, display: "flex", width: "100vw", borderBottom: "1px solid #787A80" }}>
          <div style={{ padding: "0px 120px 5px 20px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>{moment().format("dddd, MMMM Do, YYYY")}</div>
          <div style={{ padding: "0px 100px 5px 10px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>VISION PRODUCE</div>
          <div style={{ padding: "0px 10px 5px 70px", fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</div>
        </div>
      </>
    )
  })

  // await pdf.html(ReactDOMServer.renderToString(allElement), {
  //   // html2canvas: { scale:  },
  //   callback: function (doc) {
  //     // window.open(doc.output('bloburl'));
  //     //  doc.save('sample.pdf');
  //     if (!preview) {
  //       doc.autoPrint({ variant: 'non-conform' })
  //     }
  //     doc.output('dataurlnewwindow');
  //   }
  // });

  await generateAndDownloadPdf(element, preview, 'p');
}

const printBuyingSheetAll = async (preview = false) => {
  let pageNo = 0;
  const element = buyingSheetData.map((item, index) => {
    return (
      <>
        <div key={`agent-${index + 1}`} className="element-to-print" style={{ height: `${580}px` }}>
          <table className="test" width="100%" cellSpacing="0" cellPadding="0" bgcolor="f1f1f1" border="0" >
            <tbody>
              <tr>
                <td>
                  <table width="842px" cellSpacing="0" cellPadding="0" align="center" bgcolor="#fff" border="0" >
                    <tbody>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "20px 25px" }}>
                            <tbody>  <tr>
                              <td>
                                <img src={visionLogo} alt="" width="170" height="40" />
                              </td>
                              <td style={{ fontFamily: 'Outfit', fontWeight: "bold", fontSize: "18px", textAlign: "right" }}>
                                Buying Sheet - Vision
                              </td>
                            </tr> </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "12px 25px", backgroundColor: "#F8F8F8" }}>
                            <tbody>
                              <tr>
                                <td>
                                  <table width="100%" cellSpacing="0" cellPadding="0" border="0">
                                    <tbody>
                                      <tr>
                                        <td width="14%" style={{ fontSize: "12px", color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "4px" }}>Agent: </td>
                                        <td style={{ fontSize: "12px", color: "#1F222C", fontWeight: 500 }}>{item.agentCode}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <table width="100%" cellSpacing="0" cellPadding="0" border="0">
                                    <tbody>
                                      <tr>
                                        <td style={{ fontSize: "12px", color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "4px" }}>Date:</td>
                                        <td width="25%" style={{ fontSize: "12px", color: "#1F222C", fontWeight: "500" }}>{moment(fromDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      {
                        item.pages.map((page, pageIndex) => {
                          pageNo++;
                          return (
                            <>
                              <div key={`page-${pageIndex + 1}`} className="container-pdf" style={{ top: `${pageIndex ? (pageIndex * 595) + 10 : 130}px`, height: `${pageIndex ? 550 : 430}px` }}>
                                {
                                  page.map((table, tableIndex) => {
                                    if (table.rows.length === 1) {
                                      table.rows.push([{ 'Qty': '', 'BuyerCode': '' }])
                                    }
                                    return (
                                      <div key={`table-${tableIndex + 1}`} className="product-table">
                                        <div className="heading-row">
                                          <div className="column-product">Products</div>
                                          <div className="column-vp">
                                            <div className="column-qty">QTY</div>
                                            {Array.from({ length: 5 }, (_, i) => (
                                              <div key={i} className="column-vp-item">VP</div>
                                            ))}
                                          </div>
                                          <div className="column-other">Ttl</div>
                                          <div className="column-other">Cnt</div>
                                          <div className="column-other">Price</div>
                                        </div>
                                        <div className="data-row">
                                          <div className="column-product" style={{ textAlign: "center" }}>{table.productName}</div>
                                          <div>
                                            {table.rows.map((tableRow, tableRowIndex) => {
                                              let customerQtyLength = tableRow.length;
                                              return (
                                                <div key={`tableRow-${tableRowIndex + 1}`} className="column-vp">
                                                  <div className="column-qty" style={{ height: "16px", backgroundColor: "#f2f2f2" }}>{tableRow[0].Qty || '-'}</div>


                                                  {tableRow.map((row, index) => {
                                                    let qtyRows = [];
                                                    qtyRows.push(
                                                      <div key={`vp-item-${index + 1}`} className="column-vp-item" style={{ height: "16px", fontWeight: "bold" }}>{row.BuyerCode.split('VP')[1] || row.BuyerCode}</div>
                                                    )

                                                    if (index === customerQtyLength - 1 && customerQtyLength < 5) {
                                                      for (let i = 0; i < 5 - customerQtyLength; i++) {
                                                        qtyRows.push(<div className="column-vp-item"></div>)
                                                      }
                                                    }
                                                    return qtyRows
                                                  })}
                                                </div>
                                              )
                                            })}
                                          </div>
                                          <div className="column-other" style={{ backgroundColor: "#f2f2f2" }}>{table.totalQty}</div>
                                          <div className="column-other">-</div>
                                          <div className="column-other">-</div>
                                        </div>
                                      </div>
                                    )
                                  })
                                }

                              </div>
                              <div style={{ position: "absolute", top: `${pageIndex ? (pageIndex * 595) + 560 : 560}px`, display: "flex", width: "100vw", borderBottom: "1px solid #787A80" }}>
                                <div style={{ padding: "0px 240px 5px 10px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>{moment().format("dddd, MMMM Do, YYYY")}</div>
                                <div style={{ padding: "0px 240px 5px 10px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>VISION PRODUCE</div>
                                <div style={{ padding: "0px 10px 5px 50px", fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${pageNo}`}</div>
                              </div>
                            </>
                          )
                        })
                      }

                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* <div style={{position:"absolute", top:item.pages.length * 575, display:"flex", width:"100vw", borderBottom: "1px solid #787A80"}}>
          <div style={{ padding:"0px 240px 5px 20px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>{moment().format("dddd, MMMM Do, YYYY")}</div>
          <div style={{ padding:"0px 240px 5px 10px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>VISION PRODUCE</div>
          <div style={{ padding:"0px 10px 5px 50px", fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${item.pages.length}`}</div>
      </div> */}
      </>
    )
  })

  // await pdf.html(ReactDOMServer.renderToString(allElement), {
  //   // html2canvas: { scale:  },
  //   callback: function (doc) {
  //     // window.open(doc.output('bloburl'));
  //     //  doc.save('sample.pdf');
  //     if (!preview) {
  //       doc.autoPrint({ variant: 'non-conform' })
  //     }
  //     doc.output('dataurlnewwindow');
  //   }
  // });

  await generateAndDownloadPdf(element, preview, 'l');
}

export const emailProductCredit = async (creditData) => {
  const firstPageRows = 50;
  const otherPagesRows = 56;
  let tempCreditData = Object.assign({}, creditData);
  tempCreditData.products = creditData.creditDetails;
  const totalPageCount = getTotalPages(firstPageRows, otherPagesRows, [tempCreditData], true);
  let currentPage = 0;
  const mainPageHeight = totalPageCount * 840.5;
  let currentPageRow = 0;
  let startPage = 1;
  currentPage += 1;
  let subTotal = 0;
  let totalQty = 0;
  const element = <div style={{ height: `${mainPageHeight}px` }}>
    <div className="element-to-print" style={{ width: "760px" }}>
      <table
        width="100%"
        cellSpacing={0}
        cellPadding={0}
        bgcolor="ffffff"
        border={0}
      >
        <tbody>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={0}
                cellPadding={0}
                border={0}
                style={{ padding: "15px 10px 10px 10px" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontWeight: 700,
                        fontSize: 26,
                        textAlign: "left",
                        fontFamily: "primary",
                        paddingLeft: "25px"
                      }}
                    >Credit Note</td>
                    <td style={{ textAlign: "end" }}>
                      <img
                        src={visionLogo}
                        alt=""
                        width={220}
                        height={60}
                        style={{
                          textAlign: "right"
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={0}
                cellPadding={0}
                border={0}
                style={{ backgroundColor: "#fff" }}
              >
                <tbody>
                  <tr>
                    <td>
                      <table width="50%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 0px 5px 35px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.CustomerName}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.InvoiceAddress1 || creditData.tblCustomer?.InvoiceAddress2 || creditData.tblCustomer?.InvoiceAddress3}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.InvoicePostCode}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <table width="100%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 5px 5px 0px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "right"
                              }}
                            >
                              Credit Note :
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {creditData?.CNID}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "right",
                              }}
                            >
                              Date :
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {moment(creditData?.ReturnDate, "YYYY-MM-DD").format("MM/DD/YYYY")}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "right",
                              }}
                            >
                              Code :
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {creditData.tblCustomer?.CustomerCode}
                            </td>

                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={4}
                cellPadding={0}
                style={{ padding: "2px 25px" }}
              >
                <thead>
                  <tr>
                    <td colSpan={8} style={{ fontWeight: "700", paddingTop: "4px", borderBottom: "2px solid" }}></td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Qty</td>
                    <td style={{ fontSize: "12px", fontWeight: "700", color: "#1F222C", textAlign: "left", padding: "4px 4px", width: "35%" }}>Details</td>
                    <td style={{ fontSize: "12px", fontWeight: "700", color: "#1F222C", textAlign: "right", padding: "4px 4px" }}>Value</td>
                  </tr>
                  <tr>
                    <td colSpan={8} style={{ color: "#1F222C", borderBottom: "2px solid" }}></td>
                  </tr>
                </thead>
                <tbody>
                  {creditData?.creditDetails?.map((creditItem, creditIndex) => {
                    let rows = [];
                    subTotal += creditItem.ProdCreditAmt ? parseFloat(creditItem.ProdCreditAmt) : 0;
                    totalQty += creditItem.Qty ? parseInt(creditItem.Qty) : 0;
                    if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                      currentPage += 1;
                      startPage += 1;
                      currentPageRow = 0;
                    }
                    currentPageRow += 1;
                    rows.push(
                      <>
                        <tr style={{ lineHeight: 0.5 }}>
                          <td style={{ fontSize: "14px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{creditItem.Qty}</td>
                          <td style={{ fontSize: "14px", textAlign: "left", padding: "2px 4px", fontWeight: 500 }}>
                            {creditData?.units?.find(unit => unit.value == creditItem.UnitID)?.label || ''}&nbsp;&nbsp;
                            {creditData?.products?.find(product => product.value == creditItem.ProductID)?.productName || ''}
                          </td>
                          <td style={{ fontSize: "14px", textAlign: "right", padding: "2px 4px", fontWeight: 500 }}>{formatAmount(creditItem.ProdCreditAmt)}</td>
                        </tr>
                        {creditIndex === creditData.creditDetails.length - 1 && (<>
                          <tr>
                            <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid" }}></td>
                          </tr>
                          <tr style={{ lineHeight: 0.8 }}>
                            <td style={{ fontSize: "14px", textAlign: "center", padding: "2px 4px", fontWeight: 700 }}>{totalQty}</td>
                            <td colSpan={3} style={{ fontSize: "14px", textAlign: "right", padding: "2px 4px", fontWeight: 700 }}>Subtotal &nbsp;:&nbsp;&nbsp;{formatAmount(subTotal)}</td>
                          </tr></>
                        )}
                        {currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0 && (
                          <tr style={{ height: "60px", border: "1px solid red" }}>
                            <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                          </tr>
                        )}
                      </>)
                    if (creditIndex === creditData.creditDetails.length - 1 && ((creditData.creditDetails.length - firstPageRows) % firstPageRows === 0 || (creditData.creditDetails.length - firstPageRows) % otherPagesRows === 0)) {
                      currentPage += 1;
                    }
                    return rows;
                  })}

                </tbody>
              </table>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end", padding: "60px 25px 40px 35px", width: "760px" }}>
      <table
        width="50%"
        cellSpacing={4}
        cellPadding={0}
        align="right"
        style={{ fontSize: "8px" }}
      >
        {/* {creditData.tblCustomer?.StandardRebate &&
            <>
              <tr>
                <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>Less Produce&nbsp; Rebate at {invoiceData.tblCustomer?.StandardRebate}% &nbsp;: </td>
                <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(lessRebate)}</td>
              </tr>
              <tr>
                <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>Produce&nbsp; Total &nbsp;: </td>
                <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>{formatAmount(subTotal - lessRebate)}</td>
              </tr>
            </>
          } */}

        <tr>
          <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid", paddingTop: "4px" }}></td>
        </tr>
        <tr style={{ fontSize: "14px", fontWeight: 700 }}>
          <td colSpan={6} style={{ fontSize: "14px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>TOTAL &nbsp;:</td>
          <td style={{ fontSize: "14px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>{formatAmount(subTotal)}</td>
        </tr>
        <tr>
          <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", width: "20px", borderBottom: "2px solid" }}></td>
        </tr>
      </table>
    </div>
    <div style={{ position: "absolute", bottom: 0, width: "760px" }}>
      <div style={{ fontWeight: "700", color: "#1F222C", borderBottom: "2px solid", margin: "0px 25px 5px 25px" }}></div>
      <div className='d-flex justify-content-end'>
        <div style={{ width: "220px", textAlign: "justify", fontSize: "10px", paddingTop: "10px", paddingBottom: "10px", lineHeight: "12px" }}>
          <div style={{ fontSize: "12px", color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "30px" }}>{`Page ${currentPage} of ${totalPageCount}`}</div>
          <div style={{ fontWeight: "700" }}>Vision Produce Pty Ltd </div>
          ABN 11 098 952 768  <br />
          Mail Point 103, Market City,  <br />
          280 Bannister Road  <br />
          Canning Vale WA 6155  <br />
          Telephone: (08) 9456 5953  <br />
          Facsimile: (08) 9456 5948  <br />
          E-mail: accounts@visionproduce.com.au
        </div>
      </div>
    </div>
  </div>
  return element;
}

export const emailCrateCredit = async (creditData) => {
  const firstPageRows = 50;
  const otherPagesRows = 56;
  let tempCreditData = Object.assign({}, creditData);
  tempCreditData.products = creditData.creditDetails;
  const totalPageCount = getTotalPages(firstPageRows, otherPagesRows, [tempCreditData], true);
  let currentPage = 0;
  const mainPageHeight = totalPageCount * 840.5;
  let currentPageRow = 0;
  let startPage = 1;
  currentPage += 1;
  let subTotal = 0;
  let totalQty = 0;
  const element = <div style={{ height: `${mainPageHeight}px` }}>
    <div className="element-to-print" style={{ width: "760px" }}>
      <table
        width="100%"
        cellSpacing={0}
        cellPadding={0}
        bgcolor="ffffff"
        border={0}
      >
        <tbody>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={0}
                cellPadding={0}
                border={0}
                style={{ padding: "15px 10px 10px 10px" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontWeight: 700,
                        fontSize: 22,
                        textAlign: "left",
                        fontFamily: "primary",
                        paddingLeft: "25px"
                      }}
                    >Credit Note</td>
                    <td style={{ textAlign: "end" }}>
                      <img
                        src={visionLogo}
                        alt=""
                        width={220}
                        height={60}
                        style={{
                          textAlign: "right"
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={0}
                cellPadding={0}
                border={0}
                style={{ backgroundColor: "#fff" }}
              >
                <tbody>
                  <tr>
                    <td>
                      <table width="50%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 0px 5px 35px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.CustomerName}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.InvoiceAddress1 || creditData.tblCustomer?.InvoiceAddress2 || creditData.tblCustomer?.InvoiceAddress3}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "left"
                              }}
                            >
                              {creditData.tblCustomer?.InvoicePostCode}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <table width="100%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 5px 5px 0px" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "right"
                              }}
                            >
                              Credit Note :
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {creditData?.CNID}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "right",
                              }}
                            >
                              Date :
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {moment(creditData?.ReturnDate, "YYYY-MM-DD").format("MM/DD/YYYY")}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                textAlign: "right",
                              }}
                            >
                              Code :
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                textAlign: "left",
                                paddingLeft: "10px"
                              }}
                            >
                              {creditData.tblCustomer?.CustomerCode}
                            </td>

                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table
                width="100%"
                cellSpacing={4}
                cellPadding={0}
                style={{ padding: "2px 25px" }}
              >
                <thead>
                  <tr>
                    <td colSpan={8} style={{ fontWeight: "700", paddingTop: "4px", borderBottom: "2px solid" }}></td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "14px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Qty</td>
                    <td style={{ fontSize: "14px", fontWeight: "700", color: "#1F222C", textAlign: "left", padding: "4px 4px", width: "35%" }}>Details</td>
                    <td style={{ fontSize: "14px", fontWeight: "700", color: "#1F222C", textAlign: "right", padding: "4px 4px" }}>Value</td>
                  </tr>
                  <tr>
                    <td colSpan={8} style={{ color: "#1F222C", borderBottom: "2px solid" }}></td>
                  </tr>
                </thead>
                <tbody>
                  {creditData?.creditDetails?.map((creditItem, creditIndex) => {
                    let rows = [];
                    subTotal += creditItem.CrateCreditAmt ? parseFloat(creditItem.CrateCreditAmt) : 0;
                    totalQty += creditItem.Qty ? parseInt(creditItem.Qty) : 0;
                    if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                      currentPage += 1;
                      startPage += 1;
                      currentPageRow = 0;
                    }
                    currentPageRow += 1;
                    rows.push(
                      <>
                        <tr style={{ lineHeight: 0.5 }}>
                          <td style={{ fontSize: "14px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{creditItem.Qty}</td>
                          <td style={{ fontSize: "14px", textAlign: "left", padding: "2px 4px", fontWeight: 500 }}>{creditData?.crates?.find(crate => crate.ContainerID == creditItem.ContainerID)?.label || ''}</td>
                          <td style={{ fontSize: "14px", textAlign: "right", padding: "2px 4px", fontWeight: 500 }}>{formatAmount(creditItem.CrateCreditAmt)}</td>
                        </tr>
                        {currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0 && (
                          <tr style={{ height: "60px" }}>
                            <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                          </tr>
                        )}
                      </>)
                    if (creditIndex === creditData?.creditDetails.length - 1 && ((creditData?.creditDetails.length - firstPageRows) % firstPageRows === 0 || (creditData?.creditDetails.length - firstPageRows) % otherPagesRows === 0)) {
                      currentPage += 1;
                    }
                    return rows;
                  })}
                  <tr>
                    <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid" }}></td>
                  </tr>
                  <tr style={{ lineHeight: 0.8 }}>
                    <td style={{ fontSize: "14px", textAlign: "center", padding: "2px 4px", fontWeight: 700 }}>{totalQty}</td>
                    <td colSpan={3} style={{ fontSize: "14px", textAlign: "right", padding: "2px 4px", fontWeight: 700 }}>Subtotal &nbsp;:&nbsp;&nbsp;{formatAmount(subTotal)}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end", padding: "60px 25px 40px 35px", width: "760px" }}>
      <table
        width="50%"
        cellSpacing={4}
        cellPadding={0}
        align="right"
        style={{ fontSize: "8px" }}
      >
        {/* {creditData.tblCustomer?.StandardRebate &&
            <>
              <tr>
                <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>Less Produce&nbsp; Rebate at {invoiceData.tblCustomer?.StandardRebate}% &nbsp;: </td>
                <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(lessRebate)}</td>
              </tr>
              <tr>
                <td colSpan={6} style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>Produce&nbsp; Total &nbsp;: </td>
                <td style={{ fontSize: "10px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>{formatAmount(subTotal - lessRebate)}</td>
              </tr>
            </>
          } */}

        <tr>
          <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid", paddingTop: "4px" }}></td>
        </tr>
        <tr style={{ fontSize: "10px", fontWeight: 700 }}>
          <td colSpan={6} style={{ fontSize: "14px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>TOTAL &nbsp;:</td>
          <td style={{ fontSize: "14px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>{formatAmount(subTotal)}</td>
        </tr>
        <tr>
          <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", width: "20px", borderBottom: "2px solid" }}></td>
        </tr>
      </table>
    </div>
    <div style={{ position: "absolute", bottom: 0, width: "760px" }}>
      <div style={{ fontWeight: "700", color: "#1F222C", borderBottom: "2px solid", margin: "0px 25px 5px 25px" }}></div>
      <div className='d-flex justify-content-end'>
        <div style={{ width: "220px", textAlign: "justify", fontSize: "10px", paddingTop: "10px", paddingBottom: "10px", lineHeight: "12px" }}>
          <div style={{ fontSize: "12px", color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "30px" }}>{`Page ${currentPage} of ${totalPageCount}`}</div>
          <div style={{ fontWeight: "700" }}>Vision Produce Pty Ltd </div>
          ABN 11 098 952 768  <br />
          Mail Point 103, Market City,  <br />
          280 Bannister Road  <br />
          Canning Vale WA 6155  <br />
          Telephone: (08) 9456 5953  <br />
          Facsimile: (08) 9456 5948  <br />
          E-mail: accounts@visionproduce.com.au
        </div>
      </div>
    </div>
  </div>
  return element;
}

export const emailWarehouseSheet = async (warehouseSheetData) => {
  const firstPageRows = 26;
  const otherPagesRows = 32;
  const totalPageCount = getTotalPages(firstPageRows, otherPagesRows, warehouseSheetData, true);
  let currentPage = 0;
  const element = warehouseSheetData.map((ele, index) => {
    const currentTotalPage = getTotalPages(firstPageRows, otherPagesRows, [warehouseSheetData[index]], true);
    let currentPageRow = 0;
    let startPage = 1;
    currentPage += 1;
    return (
      <>
        <div className="element-to-print" style={{ height: `${currentTotalPage * 1100}px` }}>
          <table
            width="100%"
            cellSpacing={0}
            cellPadding={0}
            bgcolor="ffffff"
            border={0}
          >
            <tbody>
              <tr>
                <td>
                  <table
                    width="100%"
                    //width="600px"
                    cellSpacing={0}
                    cellPadding={0}
                    border={0}
                    style={{ padding: "25px 20px" }}
                  >
                    <tbody>
                      <tr>
                        <td>
                          <img
                            src={visionLogo}
                            alt=""
                            width={200}
                            height={60}
                          />
                        </td>
                        <td
                          style={{
                            // fontFamily: "Outfit",
                            fontWeight: 600,
                            fontSize: 20,
                            textAlign: "right"
                          }}
                        >Warehouse Sheet - Vision</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table
                    width="100%"
                    cellSpacing={0}
                    cellPadding={0}
                    border={0}
                    style={{ padding: "12px 25px", backgroundColor: "#fff" }}
                  >
                    <tbody>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing={0} cellPadding={0} border={0}>
                            <tbody>
                              <tr>
                                <td
                                  width="50%"
                                  style={{
                                    color: "#787A80",
                                    fontWeight: 500,
                                    textAlign: "left"
                                  }}
                                >
                                  Customer: {ele.CustomerCode}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <table width="100%" cellSpacing={0} cellPadding={0} border={0}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    width: "50%",
                                    color: "#787A80",
                                    fontWeight: 500,
                                    textAlign: "right"
                                  }}
                                >
                                  Date: {moment(ele.OrderDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <table
                    width="100%"
                    cellSpacing={4}
                    cellPadding={0}
                    style={{ padding: 25 }}
                  >
                    <thead>
                      <tr>
                        <td style={{ fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }} />
                        <td style={{ fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }} colSpan={2}>Vision Produce</td>
                        <td style={{ fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }}>Qty</td>
                        <td style={{ fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }}>Crate</td>
                        <td style={{ fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }}>Count</td>
                        <td style={{ fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", border: "1px solid" }}>Price</td>
                      </tr>
                    </thead>
                    <tbody>
                      {ele.products.map((product, productIndex) => {
                        let agentCode = productIndex === 0 ? product.AgentCode : ele.products[productIndex - 1].AgentCode !== product.AgentCode ? product.AgentCode : '';
                        let rows = [];
                        if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                          currentPage += 1;
                          startPage += 1;
                          currentPageRow = 0;
                        }
                        currentPageRow += 1;
                        rows.push(
                          <>
                            <tr style={{ height: "30px" }}>
                              <td style={{ width: "5%", textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.ProductID != '' && agentCode}</td>
                              <td style={{ textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{`${product.Qty} ${product.UnitName}`}</td>
                              <td style={{ textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.ProductName}</td>
                              <td style={{ textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.Qty}-{productIndex}</td>
                              <td style={{ textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.ContainerName}</td>
                              <td style={{ textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>{product.Count}</td>
                              <td style={{ textAlign: "right", padding: "4px 4px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}></td>
                            </tr>
                            {currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0 && (
                              <tr style={{ height: "60px" }}>
                                <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                              </tr>
                            )}
                          </>)
                        if (productIndex === ele.products.length - 1 && ((ele.products.length - firstPageRows) % firstPageRows === 0 || (ele.products.length - firstPageRows) % otherPagesRows === 0)) {
                          currentPage += 1;
                        }
                        return rows;
                      })}
                      <tr>
                        <td colSpan={7} style={{ fontSize: "16px", textAlign: "right", padding: "10px 4px 5px", borderColor: "#787A80", borderStyle: "solid", fontWeight: 500, color: "#1F222C", border: "1px solid" }}>
                          {`Item Count: ${ele.TotalProducts}`}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ display: "flex", width: "100vw", justifyContent: "space-around", borderBottom: "1px solid #787A80" }}>
          <div style={{ padding: "0px 120px 5px 20px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>{moment().format("dddd, MMMM Do, YYYY")}</div>
          <div style={{ padding: "0px 140px 5px 10px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>VISION PRODUCE</div>
          <div style={{ padding: "0px 10px 5px 30px", fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</div>
        </div>
      </>
    )
  })

  return element;
}

export const emailBuyingSheet = async (buyingSheetData, fromDate) => {
  let pageNo = 0;
  const element = buyingSheetData.map((item, index) => {
    return (
      <>
        <div key={`agent-${index + 1}`} className="element-to-print" style={{ height: `${580}px` }}>
          <table className="test" width="100%" cellSpacing="0" cellPadding="0" bgcolor="ffffff" border="0" >
            <tbody>
              <tr>
                <td>
                  <table width="1100px" cellSpacing="0" cellPadding="0" align="center" bgcolor="#fff" border="0" >
                    <tbody>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "20px 25px" }}>
                            <tbody>  <tr>
                              <td>
                                <img src={visionLogo} alt="" width="170" height="40" />
                              </td>
                              <td style={{ fontFamily: 'Outfit', fontWeight: "bold", fontSize: "18px", textAlign: "right" }}>
                                Buying Sheet - Vision
                              </td>
                            </tr> </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "12px 25px", backgroundColor: "#F8F8F8" }}>
                            <tbody>
                              <tr>
                                <td>
                                  <table width="100%" cellSpacing="0" cellPadding="0" border="0">
                                    <tbody>
                                      <tr>
                                        <td width="14%" style={{ color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "4px" }}>Agent: </td>
                                        <td style={{ color: "#1F222C", fontWeight: 500 }}>{item.agentCode}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <table width="100%" cellSpacing="0" cellPadding="0" border="0">
                                    <tbody>
                                      <tr>
                                        <td style={{ color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "4px" }}>Date:</td>
                                        <td width="25%" style={{ color: "#1F222C", fontWeight: "500" }}>{moment(fromDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      {
                        item.pages.map((page, pageIndex) => {
                          pageNo++;
                          return (
                            <>
                              <div key={`page-${pageIndex + 1}`} className="container-pdf email" style={{ top: `${pageIndex ? (pageIndex * 805) + 10 : 130}px`, height: `${pageIndex ? 550 : 650}px` }}>
                                {
                                  page.map((table, tableIndex) => {
                                    if (table.rows.length === 1) {
                                      table.rows.push([{ 'Qty': '', 'BuyerCode': '' }])
                                    }
                                    return (
                                      <div key={`table-${tableIndex + 1}`} className="product-table">
                                        <div className="heading-row">
                                          <div className="column-product email">Products</div>
                                          <div className="column-vp email">
                                            <div className="column-qty email">QTY</div>
                                            {Array.from({ length: 5 }, (_, i) => (
                                              <div key={i} className="column-vp-item email">VP</div>
                                            ))}
                                          </div>
                                          <div className="column-other email">Ttl</div>
                                          <div className="column-other email">Cnt</div>
                                          <div className="column-other email">Price</div>
                                        </div>
                                        <div className="data-row">
                                          <div className="column-product email" style={{ textAlign: "center" }}>{table.productName}</div>
                                          <div>
                                            {table.rows.map((tableRow, tableRowIndex) => {
                                              let customerQtyLength = tableRow.length;
                                              return (
                                                <div key={`tableRow-${tableRowIndex + 1}`} className="column-vp email">
                                                  <div className="column-qty email" style={{ height: "20px", backgroundColor: "#f2f2f2", fontSize: "12px" }}>{tableRow[0].Qty || '-'}</div>


                                                  {tableRow.map((row, index) => {
                                                    let qtyRows = [];
                                                    qtyRows.push(
                                                      <div key={`vp-item-${index + 1}`} className="column-vp-item email" style={{ height: "20px", fontSize: "12px", fontWeight: "bold" }}>{row.BuyerCode.split('VP')[1] || row.BuyerCode}</div>
                                                    )

                                                    if (index === customerQtyLength - 1 && customerQtyLength < 5) {
                                                      for (let i = 0; i < 5 - customerQtyLength; i++) {
                                                        qtyRows.push(<div className="column-vp-item email"></div>)
                                                      }
                                                    }
                                                    return qtyRows
                                                  })}
                                                </div>
                                              )
                                            })}
                                          </div>
                                          <div className="column-other email" style={{ backgroundColor: "#f2f2f2" }}>{table.totalQty}</div>
                                          <div className="column-other email">-</div>
                                          <div className="column-other email">-</div>
                                        </div>
                                      </div>
                                    )
                                  })
                                }

                              </div>
                              <div style={{ position: "absolute", top: `${pageIndex ? (pageIndex * 805) + 760 : 760}px`, display: "flex", width: "100vw", justifyContent: "space-around", borderBottom: "1px solid #787A80" }}>
                                <div style={{ padding: "0px 240px 5px 0px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>{moment().format("dddd, MMMM Do, YYYY")}</div>
                                <div style={{ padding: "0px 240px 5px 0px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>VISION PRODUCE</div>
                                <div style={{ padding: "0px 10px 5px 50px", fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${pageNo}`}</div>
                              </div>
                            </>
                          )
                        })
                      }

                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </>
    )
  })

  return element;
}

export const emailPurchaseSheet = async (buyingSheetData, fromDate) => {
  const firstPageRows = 26;
  const otherPagesRows = 32;
  const totalPageCount = getTotalPages(firstPageRows, otherPagesRows, buyingSheetData, false);
  let currentPage = 0;
  const element = buyingSheetData.map((item, index) => {
    const currentTotalPage = getTotalPages(firstPageRows, otherPagesRows, [buyingSheetData[index]], false);
    let currentPageRow = 0;
    let startPage = 1;
    currentPage += 1;
    return (
      <>
        <div className="element-to-print" style={{ height: `${currentTotalPage * 1080}px` }}>
          <table width="100%" cellSpacing="0" cellPadding="0" bgcolor="ffffff" border="0" >
            <tbody>
              <tr>
                <td>
                  <table width="100%" cellSpacing="0" cellPadding="0" align="center" bgcolor="#fff" border="0" >
                    <tbody>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "20px 25px" }}>
                            <tbody>  <tr>
                              <td>
                                <img src={visionLogo} alt="" width="170" height="40" />
                              </td>
                              <td style={{ fontFamily: 'Outfit', fontWeight: "bold", fontSize: "18px", textAlign: "right" }}>
                                Purchase Order - Vision
                              </td>
                            </tr> </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table width="100%" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "12px 25px", backgroundColor: "#F8F8F8" }}>
                            <tbody>
                              <tr>
                                <td>
                                  <table width="100%" cellSpacing="0" cellPadding="0" border="0">
                                    <tbody>
                                      <tr>
                                        <td width="14%" style={{ color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "4px" }}>Agent: </td>
                                        <td style={{ color: "#1F222C", fontWeight: 500 }}>{item.agentCode}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <table width="100%" cellSpacing="0" cellPadding="0" border="0">
                                    <tbody>
                                      <tr>
                                        <td style={{ color: "#787A80", fontWeight: "500", textAlign: "right", paddingRight: "4px" }}>Date:</td>
                                        <td width="30%" style={{ color: "#1F222C", fontWeight: "500" }}>{moment(fromDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table className="product-table" width="100%" align="center" cellSpacing="0" cellPadding="0" border="0" style={{ padding: "25px 25px 15px 25px" }}>
                            <thead>
                              <tr>
                                <td style={{
                                  fontSize: "14px", fontWeight: 500,
                                  color: "#787A80", width: "140px", textAlign: "center"
                                }}>Products</td>
                                <td style={{ padding: "12px", fontSize: "14px" }}>Ttl</td>
                              </tr>
                            </thead>
                            <tbody>
                              {item.products.map((product, productIndex) => {
                                let rows = [];
                                if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                                  currentPage += 1;
                                  startPage += 1;
                                  currentPageRow = 0;
                                }
                                currentPageRow += 1;
                                rows.push(<tr key={productIndex}>
                                  <td style={{ textAlign: "center", fontSize: "14px" }}>{product.ProductName}</td>
                                  <td style={{ textAlign: "center", fontSize: "14px" }}>{product.TotalQty}</td>
                                  {productIndex !== item.products.length - 1 && currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0 && (
                                    <tr style={{ height: "60px" }}>
                                      <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                                    </tr>
                                  )}
                                </tr>)
                                return rows;
                              })}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ display: "flex", width: "100vw", justifyContent: "space-around", borderBottom: "1px solid #787A80" }}>
          <div style={{ padding: "0px 120px 5px 20px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>{moment().format("dddd, MMMM Do, YYYY")}</div>
          <div style={{ padding: "0px 100px 5px 10px", fontSize: "10px", color: "#787A80", fontWeight: "500" }}>VISION PRODUCE</div>
          <div style={{ padding: "0px 10px 5px 70px", fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</div>
        </div>
      </>
    )
  })

  return element
}

export const emailInvoice = async (invoiceData) => {
  const fileName = `Vision Product Invoice ${invoiceData?.InvoiceNo}_${invoiceData?.tblCustomer?.CustomerCode}`
  let crateDeposit = 0;
  let crateHireFee = 0;
  let crateHireGST = 0;
  let subTotal = 0;
  let totalGST = 0;
  const cratesDetails = await calculateCrates(invoiceData?.tblOrderDetails);
  let crateTotal = 0;
  let lessRebate = 0;
  const showRRP = invoiceData?.tblCustomer?.RRP ? true : false;
  const element =
    <div style={{ height: "840px" }}>
      <div className="element-to-print" style={{ width: "1050px" }}>
        <table
          width="100%"
          cellSpacing={0}
          cellPadding={0}
          bgcolor="ffffff"
          border={0}
        >
          <tbody>
            <tr>
              <td>
                <table
                  width="100%"
                  cellSpacing={0}
                  cellPadding={0}
                  border={0}
                  style={{ padding: "15px 10px 0px 10px" }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          fontWeight: 700,
                          fontSize: 28,
                          textAlign: "left",
                          fontFamily: "primary",
                          paddingLeft: "25px"
                        }}
                      >TAX INVOICE</td>
                      <td style={{ textAlign: "end" }}>
                        <img
                          src={visionLogo}
                          alt=""
                          width={240}
                          height={70}
                          style={{
                            textAlign: "right"
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table
                  width="100%"
                  cellSpacing={0}
                  cellPadding={0}
                  border={0}
                  style={{ backgroundColor: "#fff" }}
                >
                  <tbody>
                    <tr>
                      <td>
                        <table width="100%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "12px 0px 5px 35px" }}>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  textAlign: "left"
                                }}
                              >
                                {invoiceData.tblCustomer?.CustomerName}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  textAlign: "left"
                                }}
                              >
                                {invoiceData.tblCustomer?.InvoiceAddress1 || invoiceData.tblCustomer?.InvoiceAddress2 || invoiceData.tblCustomer?.InvoiceAddress3}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  textAlign: "left"
                                }}
                              >
                                {invoiceData.tblCustomer?.InvoicePostCode}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <table width="100%" cellSpacing={0} cellPadding={0} border={0} style={{ padding: "5px 5px 5px 0px" }}>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  textAlign: "right"
                                }}
                              >
                                Invoice No :
                              </td>
                              <td
                                style={{
                                  fontSize: "18px",
                                  textAlign: "right"
                                }}
                              >
                                {invoiceData.InvoiceNo}
                              </td>
                              <td
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  textAlign: "right"
                                }}
                              >
                                Date :
                              </td>
                              <td
                                style={{
                                  fontSize: "18px",
                                  textAlign: "left",
                                  paddingLeft: "10px"
                                }}
                              >
                                {moment(invoiceData.InvoiceDate, "YYYY-MM-DD").format("MM/DD/YYYY")}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  textAlign: "right"
                                }}
                              >
                                Code :
                              </td>
                              <td
                                style={{
                                  fontSize: "18px",
                                  textAlign: "right"
                                }}
                              >
                                {invoiceData.tblCustomer?.CustomerCode}
                              </td>
                              <td
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  textAlign: "right"
                                }}
                              >
                                PO :
                              </td>
                              <td
                                style={{
                                  fontSize: "18px",
                                  textAlign: "left",
                                  paddingLeft: "10px"
                                }}
                              >
                                {invoiceData.PurchaseOrder}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table
                  width="100%"
                  cellSpacing={0}
                  cellPadding={0}
                  style={{ padding: "20px 25px 0px 25px" }}
                >
                  <tr>
                    <td style={{ fontSize: "18px", fontWeight: "700", textAlign: "left", paddingLeft: "10px" }}>Delivery &nbsp; Instructions  &nbsp;  : &nbsp;  {invoiceData.DeliveryInstructions}</td>
                  </tr>
                  <tr>
                    <td colSpan={8} style={{ fontWeight: "700", paddingTop: "4px", borderBottom: "2px solid" }}></td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table
                  width="100%"
                  cellSpacing={4}
                  cellPadding={0}
                  style={{ padding: "2px 25px" }}
                >
                  <thead>
                    <tr>
                      <td style={{ fontSize: "16px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Code</td>
                      <td style={{ fontSize: "16px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Qty</td>
                      <td style={{ fontSize: "16px", fontWeight: "700", color: "#1F222C", textAlign: "left", padding: "4px 4px", width: "8%" }}>Type</td>
                      <td style={{ fontSize: "16px", fontWeight: "700", color: "#1F222C", textAlign: "left", padding: "4px 4px", width: "35%" }}>Product&nbsp; Details</td>
                      <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px", width: "6%" }}>Cnt &nbsp;/Wt</td>
                      {showRRP && <td style={{ fontSize: "10px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>RRP</td>}
                      <td style={{ fontSize: "16px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Unit Price</td>
                      <td style={{ fontSize: "16px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>Value</td>
                      <td style={{ fontSize: "16px", fontWeight: "700", color: "#1F222C", textAlign: "center", padding: "4px 4px" }}>GST</td>
                    </tr>
                    <tr>
                      <td colSpan={9} style={{ color: "#1F222C", borderBottom: "2px solid" }}></td>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceData?.tblOrderDetails?.map((product, productIndex) => {
                      let rows = [];
                      crateDeposit += product.CrateValue;
                      crateHireFee += product.CrateHire;
                      crateHireGST += product.CrateGST;
                      subTotal += product.ExtSell;
                      totalGST += product.GSTAmount;
                      lessRebate = subTotal * (invoiceData.tblCustomer?.StandardRebate / 100)
                      // if (currentPageRow !== 0 && currentPageRow % (startPage === 1 ? firstPageRows : otherPagesRows) === 0) {
                      //   currentPage += 1;
                      //   startPage += 1;
                      //   currentPageRow = 0;
                      // }
                      // currentPageRow += 1;
                      rows.push(
                        <>
                          <tr style={{ lineHeight: 0.5 }}>
                            <td style={{ fontSize: "16px", textAlign: "center", padding: "4px 4px", fontWeight: 500 }}>{product.tblProduct?.ProductCode}</td>
                            <td style={{ fontSize: "16px", textAlign: "center", padding: "4px 4px", fontWeight: 500 }}>{product.Qty}</td>
                            <td style={{ fontSize: "16px", textAlign: "left", padding: "4px 4px", fontWeight: 500 }}>{product.tblContainer?.TypeInCode}</td>
                            <td style={{ fontSize: "16px", textAlign: "left", padding: "4px 4px", fontWeight: 500 }}>{product.ProductName}</td>
                            <td style={{ fontSize: "16px", textAlign: "center", padding: "4px 4px", fontWeight: 500 }}>{product.Count || 0}</td>
                            {showRRP && <td style={{ fontSize: "10px", textAlign: "center", padding: "2px 4px", fontWeight: 500 }}>{product.RRP || 0}</td>}
                            <td style={{ fontSize: "16px", textAlign: "right", padding: "4px 4px", fontWeight: 500 }}>{formatAmount(product.SellPrice)}</td>
                            <td style={{ fontSize: "16px", textAlign: "right", padding: "4px 4px", fontWeight: 500 }}>{formatAmount(product.ExtSell)}</td>
                            <td style={{ fontSize: "16px", textAlign: "right", padding: "4px 4px", fontWeight: 500 }}>{formatAmount(product.GSTAmount)}</td>
                          </tr>
                          {/* {currentPageRow !== 0 && currentPageRow % (startPage === 1? firstPageRows : otherPagesRows) === 0 && (
                    <tr style={{ height: "60px" }}>
                      <td colSpan="7" style={{ fontSize: "10px", color: "#787A80", fontWeight: "500", textAlign: "right" }}>{`Page ${currentPage} of ${totalPageCount}`}</td>
                    </tr>
                  )} */}
                        </>)
                      // if (productIndex === ele.products.length - 1 && ((ele.products.length - firstPageRows) % firstPageRows === 0 || (ele.products.length - firstPageRows) % otherPagesRows === 0)) {
                      //   currentPage += 1;
                      // }
                      return rows;
                    })}
                    <tr>
                      <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid" }}></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
      <div style={{ display: "flex", padding: "5px 15px 40px 35px", width: "1035px" }}>
        <div style={{ width: "400px" }}>
          {cratesDetails && <>
            <div style={{ fontSize: "18px", padding: "2px", fontWeight: 700, backgroundColor: "#D3D3D3" }}>
              <span>Crate Summary</span>
            </div>
            <div>
              <table
                width="100%"
                cellSpacing={4}
                cellPadding={0}
                style={{ fontSize: "16px" }}
              >
                {Object.keys(cratesDetails).map((key) => {
                  let crateItem = cratesDetails[key];
                  crateTotal += crateItem.totalPrice
                  return (
                    <tr>
                      <td style={{ textAlign: "left" }}>{crateItem.description}</td>
                      <td style={{ textAlign: "left" }}>{crateItem.qty}</td>
                      <td style={{ textAlign: "right" }}>{crateItem.label}</td>
                      <td style={{ textAlign: "right", paddingBottom: "4px" }}>{formatAmount(crateItem.totalPrice)}</td>
                    </tr>
                  )
                })}
                <tr>
                  <td colSpan={4} style={{ fontSize: "12px", fontWeight: "700", color: "#1F222C", textAlign: "center", borderBottom: "1px solid" }}></td>
                </tr>
                <tr>
                  <td colSpan={3} style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 800, }}>Crate Total &nbsp;: </td>
                  <td style={{ fontSize: "16px", textAlign: "right", fontWeight: 800 }}>{formatAmount(crateTotal)}</td>
                </tr>
              </table>
            </div>
          </>
          }
        </div>
        <div style={{ width: "650px", marginLeft: "60px" }}>
          <table
            width="100%"
            cellSpacing={4}
            cellPadding={0}
            style={{ fontSize: "10px" }}
          >
            <tr>
              <td colSpan={6} style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>Produce&nbsp; Subtotal &nbsp;: </td>
              <td style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(subTotal)}</td>
              <td style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(totalGST)}</td>
            </tr>
            {invoiceData.tblCustomer?.StandardRebate &&
              <>
                <tr>
                  <td colSpan={6} style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>Less Produce&nbsp; Rebate at {invoiceData.tblCustomer?.StandardRebate}% &nbsp;: </td>
                  <td style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingBottom: "2px" }}>{formatAmount(lessRebate)}</td>
                </tr>
                <tr>
                  <td colSpan={6} style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>Produce&nbsp; Total &nbsp;: </td>
                  <td style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C" }}>{formatAmount(subTotal - lessRebate)}</td>
                </tr>
              </>
            }
            <tr>
              <td colSpan={6} style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "10px" }}>Plus Crate Deposit &nbsp;: </td>
              <td style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "10px" }}>{formatAmount(crateDeposit - crateHireFee)}</td>
            </tr>
            <tr>
              <td colSpan={6} style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "4px" }}>Plus Crate Hire Fee &nbsp;: </td>
              <td style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "4px" }}>{formatAmount(crateHireFee)}</td>
            </tr>
            <tr>
              <td colSpan={6} style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "4px" }}>Plus Crate Hire GST &nbsp;: </td>
              <td style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "4px" }}>{formatAmount(crateHireGST)}</td>
            </tr>
            <tr>
              <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", borderBottom: "1px solid", paddingTop: "4px" }}></td>
            </tr>
            <tr style={{ fontSize: "16px", fontWeight: 700 }}>
              <td colSpan={6} style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>INVOICE &nbsp;TOTAL &nbsp;(inc GST) &nbsp;:</td>
              <td style={{ fontSize: "16px", textAlign: "right", padding: "0px 4px", fontWeight: 700, color: "#1F222C", paddingTop: "8px", paddingBottom: "6px" }}>{formatAmount((subTotal - lessRebate) + crateDeposit + crateHireGST)}</td>
            </tr>
            <tr>
              <td colSpan={8} style={{ fontWeight: "700", color: "#1F222C", width: "20px", borderBottom: "2px solid" }}></td>
            </tr>
          </table>
        </div>
      </div>
      <div style={{ position: "absolute", bottom: 0, width: "1050px" }}>
        <div style={{ fontWeight: "700", color: "#1F222C", borderBottom: "2px solid", margin: "0px 25px 5px 25px" }}></div>
        <div className='d-flex'>
          <div className='' style={{ width: "570px", textAlign: "justify", fontSize: "16px", paddingLeft: "30px" }}>

            <div style={{ paddingBottom: "8px", fontWeight: "700" }}>
              Where produce is marked with an Asterisk (*), the item attracts GST and
              the GST amount is shown. Items without an asterisk are GST exempt.
            </div>

            <div className='pb-2' style={{ fontWeight: "700" }}>All Claims for credit must be received within 24 hours of receipt of goods.</div>

            <div className='pb-2'>Where the Sell Price is red and/or bold, your price has gone up since the last time you
              ordered this product.</div>

            <div className='pb-2'>Where the Sell Price is green and/or underlined, your price has gone down since the last
              time you ordered this product.</div>

            <div className='pb-2'>*All products are Australian grown unless specified on our invoice.</div>
          </div>
          <div style={{ width: "200px" }}></div>
          <div style={{ width: "220px", textAlign: "justify", fontSize: "16px", paddingTop: "30px", lineHeight: "20px" }}>
            {/* <div style={{position:"absolute", right:"200px", bottom:"50px"}}>Page 1 of 1</div> */}
            <div style={{ fontWeight: "700" }}>Vision Produce Pty Ltd </div>
            ABN 11 098 952 768  <br />
            Mail Point 103, Market City,  <br />
            280 Bannister Road  <br />
            Canning Vale WA 6155  <br />
            Telephone: (08) 9456 5953  <br />
            Facsimile: (08) 9456 5948  <br />
            E-mail: accounts@visionproduce.com.au
          </div>
        </div>
      </div>
    </div>

  return element;
}